// ─── EXPORT SCREEN ─────────────────────────────────────────────
const EXPORT_RULE_INITIAL = {
  name: '',
  destination: '',
  active: true,
  criteria: { productIds: [], sources: [], countries: [], states: [], paidOnly: true, excludeRouted: true, includeFulfilled: false, datePreset: '', dateFrom: '', dateTo: '', minQuantity: '', maxQuantity: '', requireProduct: false, requireShippingAddress: false },
  mapping: EXPORT_PROFILES[0].mapping.map(([header, field]) => ({ header, field })),
};

const COUNTRY_GROUPS = [
  { name:'North America', countries:[
    ['US','United States'], ['CA','Canada'], ['MX','Mexico'],
    ['BZ','Belize'], ['CR','Costa Rica'], ['SV','El Salvador'], ['GT','Guatemala'], ['HN','Honduras'], ['NI','Nicaragua'], ['PA','Panama'],
    ['AG','Antigua and Barbuda'], ['BS','Bahamas'], ['BB','Barbados'], ['CU','Cuba'], ['DM','Dominica'], ['DO','Dominican Republic'], ['GD','Grenada'], ['HT','Haiti'], ['JM','Jamaica'],
    ['KN','Saint Kitts and Nevis'], ['LC','Saint Lucia'], ['VC','Saint Vincent and the Grenadines'], ['TT','Trinidad and Tobago'],
  ] },
  { name:'South America', countries:[
    ['AR','Argentina'], ['BO','Bolivia'], ['BR','Brazil'], ['CL','Chile'], ['CO','Colombia'], ['EC','Ecuador'], ['GY','Guyana'], ['PY','Paraguay'], ['PE','Peru'],
    ['SR','Suriname'], ['UY','Uruguay'], ['VE','Venezuela'],
  ] },
  { name:'Europe', countries:[
    ['AL','Albania'], ['AD','Andorra'], ['AT','Austria'], ['BY','Belarus'], ['BE','Belgium'], ['BA','Bosnia and Herzegovina'], ['BG','Bulgaria'], ['HR','Croatia'], ['CY','Cyprus'],
    ['CZ','Czechia'], ['DK','Denmark'], ['EE','Estonia'], ['FI','Finland'], ['FR','France'], ['DE','Germany'], ['GR','Greece'],
    ['HU','Hungary'], ['IS','Iceland'], ['IE','Ireland'], ['IT','Italy'], ['LV','Latvia'], ['LI','Liechtenstein'], ['LT','Lithuania'],
    ['LU','Luxembourg'], ['MT','Malta'], ['MD','Moldova'], ['MC','Monaco'], ['ME','Montenegro'], ['NL','Netherlands'], ['MK','North Macedonia'], ['NO','Norway'], ['PL','Poland'], ['PT','Portugal'],
    ['RO','Romania'], ['RU','Russia'], ['SM','San Marino'], ['RS','Serbia'], ['SK','Slovakia'], ['SI','Slovenia'], ['ES','Spain'], ['SE','Sweden'],
    ['CH','Switzerland'], ['UA','Ukraine'], ['GB','United Kingdom'],
  ] },
  { name:'Africa', countries:[
    ['DZ','Algeria'], ['AO','Angola'], ['BJ','Benin'], ['BW','Botswana'], ['BF','Burkina Faso'], ['BI','Burundi'], ['CV','Cabo Verde'], ['CM','Cameroon'], ['CF','Central African Republic'], ['TD','Chad'],
    ['KM','Comoros'], ['CG','Congo'], ['CD','Congo DR'], ['CI',"Cote d'Ivoire"], ['DJ','Djibouti'], ['EG','Egypt'], ['GQ','Equatorial Guinea'], ['ER','Eritrea'], ['SZ','Eswatini'], ['ET','Ethiopia'],
    ['GA','Gabon'], ['GM','Gambia'], ['GH','Ghana'], ['GN','Guinea'], ['GW','Guinea-Bissau'], ['KE','Kenya'], ['LS','Lesotho'], ['LR','Liberia'], ['LY','Libya'], ['MG','Madagascar'],
    ['MW','Malawi'], ['ML','Mali'], ['MR','Mauritania'], ['MU','Mauritius'], ['MA','Morocco'], ['MZ','Mozambique'], ['NA','Namibia'], ['NE','Niger'], ['NG','Nigeria'],
    ['RW','Rwanda'], ['ST','Sao Tome and Principe'], ['SN','Senegal'], ['SC','Seychelles'], ['SL','Sierra Leone'], ['SO','Somalia'], ['ZA','South Africa'],
    ['SS','South Sudan'], ['SD','Sudan'], ['TZ','Tanzania'], ['TG','Togo'], ['TN','Tunisia'], ['UG','Uganda'], ['ZM','Zambia'], ['ZW','Zimbabwe'],
  ] },
  { name:'Asia', countries:[
    ['AF','Afghanistan'], ['AM','Armenia'], ['AZ','Azerbaijan'], ['BH','Bahrain'], ['BD','Bangladesh'], ['BT','Bhutan'], ['BN','Brunei'], ['KH','Cambodia'], ['CN','China'],
    ['GE','Georgia'], ['IN','India'], ['ID','Indonesia'], ['IR','Iran'], ['IQ','Iraq'], ['IL','Israel'], ['JP','Japan'], ['JO','Jordan'],
    ['KZ','Kazakhstan'], ['KW','Kuwait'], ['KG','Kyrgyzstan'], ['LA','Laos'], ['LB','Lebanon'], ['MY','Malaysia'], ['MV','Maldives'], ['MN','Mongolia'], ['MM','Myanmar'],
    ['NP','Nepal'], ['KP','North Korea'], ['OM','Oman'], ['PK','Pakistan'], ['PH','Philippines'], ['QA','Qatar'], ['SA','Saudi Arabia'], ['SG','Singapore'], ['KR','South Korea'],
    ['LK','Sri Lanka'], ['SY','Syria'], ['TJ','Tajikistan'], ['TH','Thailand'], ['TL','Timor-Leste'], ['TR','Turkey'], ['TM','Turkmenistan'], ['AE','United Arab Emirates'],
    ['UZ','Uzbekistan'], ['VN','Vietnam'], ['YE','Yemen'],
  ] },
  { name:'Oceania', countries:[
    ['AU','Australia'], ['FJ','Fiji'], ['KI','Kiribati'], ['MH','Marshall Islands'], ['FM','Micronesia'], ['NR','Nauru'], ['NZ','New Zealand'], ['PW','Palau'], ['PG','Papua New Guinea'],
    ['WS','Samoa'], ['SB','Solomon Islands'], ['TO','Tonga'], ['TV','Tuvalu'], ['VU','Vanuatu'],
  ] },
];
const CONTINENT_ICON_FILES = {
  'North America':'north_america_black.webp',
  'South America':'south_america_black.webp',
  Europe:'europe_black.webp',
  Africa:'africa_black.webp',
  Asia:'asia_black.webp',
  Oceania:'oceania_black.webp',
};
const REGION_ICON_CONTINENTS = {
  'United States':'North America',
  Canada:'North America',
  'United Kingdom':'Europe',
  'European Union':'Europe',
  'Europe non-EU':'Europe',
  Australia:'Oceania',
  LATAM:'South America',
  APAC:'Asia',
};
const RegionIcon = ({ name, size = 32 }) => {
  const continent = REGION_ICON_CONTINENTS[name] || name;
  const file = CONTINENT_ICON_FILES[continent];
  if (!file) return <span style={{ width:size, height:size, flexShrink:0 }}/>;
  return (
    <span style={{ width:size, height:size, display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
      <img src={`/assets/continent_icons/${file}`} alt="" style={{ width:size, height:size, objectFit:'contain', opacity:0.68 }}/>
    </span>
  );
};
const ALL_COUNTRIES = COUNTRY_GROUPS.flatMap(group => group.countries.map(([code, name]) => ({ code, name, continent:group.name })));
const ALL_COUNTRY_CODES = ALL_COUNTRIES.map(country => country.code);
const EU_COUNTRY_CODES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
const countryCodesInGroup = name => COUNTRY_GROUPS.find(group => group.name === name)?.countries.map(([code]) => code) || [];
const EXPORT_REGION_SHORTCUTS = [
  { name:'European Union', flag:'eu', codes:EU_COUNTRY_CODES },
  { name:'United States', flag:'us', codes:['US'] },
  { name:'Canada', flag:'ca', codes:['CA'] },
  { name:'Australia', flag:'au', codes:['AU'] },
  { name:'United Kingdom', flag:'gb', codes:['GB'] },
];
const NO_PRODUCTS_SELECTED = '__NONE__';
const NO_COUNTRIES_SELECTED = '__NONE__';
const NO_US_STATES_SELECTED = '__NONE__';
const US_STATE_OPTIONS = [
  ['AL','Alabama'], ['AK','Alaska'], ['AZ','Arizona'], ['AR','Arkansas'], ['CA','California'], ['CO','Colorado'], ['CT','Connecticut'], ['DE','Delaware'], ['FL','Florida'], ['GA','Georgia'], ['HI','Hawaii'], ['ID','Idaho'], ['IL','Illinois'], ['IN','Indiana'], ['IA','Iowa'], ['KS','Kansas'], ['KY','Kentucky'], ['LA','Louisiana'], ['ME','Maine'], ['MD','Maryland'], ['MA','Massachusetts'], ['MI','Michigan'], ['MN','Minnesota'], ['MS','Mississippi'], ['MO','Missouri'], ['MT','Montana'], ['NE','Nebraska'], ['NV','Nevada'], ['NH','New Hampshire'], ['NJ','New Jersey'], ['NM','New Mexico'], ['NY','New York'], ['NC','North Carolina'], ['ND','North Dakota'], ['OH','Ohio'], ['OK','Oklahoma'], ['OR','Oregon'], ['PA','Pennsylvania'], ['RI','Rhode Island'], ['SC','South Carolina'], ['SD','South Dakota'], ['TN','Tennessee'], ['TX','Texas'], ['UT','Utah'], ['VT','Vermont'], ['VA','Virginia'], ['WA','Washington'], ['WV','West Virginia'], ['WI','Wisconsin'], ['WY','Wyoming'],
];
const ALL_US_STATE_CODES = US_STATE_OPTIONS.map(([code]) => code);
const US_STATE_NAME_TO_CODE = Object.fromEntries(US_STATE_OPTIONS.flatMap(([code, name]) => [[code.toLowerCase(), code], [name.toLowerCase(), code]]));
const normalizeUsStateCode = value => {
  const key = String(value || '').trim().replace(/\./g, '').replace(/\s+/g, ' ').toLowerCase();
  return US_STATE_NAME_TO_CODE[key] || key.toUpperCase();
};
const EXPORT_SOURCE_GROUPS = SOURCE_TAB_GROUPS.map(group => ({ name:group.title, sources:group.items.map(source => source.id) }));
const ALL_EXPORT_SOURCES = EXPORT_SOURCE_GROUPS.flatMap(group => group.sources);
const NO_SOURCES_SELECTED = '__NONE__';

const dashboardDateKey = value => {
  const text = String(value || '').trim();
  const direct = text.match(/^(\d{4}-\d{2}-\d{2})/);
  if (direct) return direct[1];
  const parsed = new Date(text);
  if (Number.isNaN(parsed.getTime())) return '';
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const dashboardDateOffset = days => {
  const date = new Date();
  date.setHours(12, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return dashboardDateKey(date);
};

const exportDateBounds = criteria => {
  if (criteria?.datePreset === 'today') {
    const today = dashboardDateOffset(0);
    return { from:today, to:today };
  }
  if (criteria?.datePreset === 'last7') return { from:dashboardDateOffset(-6), to:dashboardDateOffset(0) };
  if (criteria?.datePreset === 'last30') return { from:dashboardDateOffset(-29), to:dashboardDateOffset(0) };
  if (criteria?.datePreset === 'custom') return { from:criteria.dateFrom || '', to:criteria.dateTo || '' };
  return { from:'', to:'' };
};

const orderMatchesExportDate = (order, criteria) => {
  const bounds = exportDateBounds(criteria);
  if (!bounds.from && !bounds.to) return true;
  const orderDate = dashboardDateKey(order.date || order.created_at || order.createdAt);
  if (!orderDate) return false;
  if (bounds.from && orderDate < bounds.from) return false;
  if (bounds.to && orderDate > bounds.to) return false;
  return true;
};

const ExportDestinationListSkeleton = () => (
  <div style={{ display:'grid' }} aria-label="Loading fulfillment destinations" role="status">
    {[0, 1, 2, 3].map(idx => (
      <div key={idx} style={{ padding:'12px 14px', borderBottom:idx === 3 ? 'none' : '1px solid #F3F4F6' }}>
        <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'center' }}>
          <span style={{ minWidth:0, display:'flex', alignItems:'center', gap:8, flex:1 }}>
            <SkeletonPill width={22} height={22} style={{ borderRadius:5, flexShrink:0 }}/>
            <SkeletonPill width={idx === 1 ? '66%' : idx === 2 ? '56%' : '74%'} height={15}/>
          </span>
          <SkeletonPill width={28} height={17} style={{ borderRadius:5, flexShrink:0 }}/>
        </div>
        <SkeletonPill width={idx === 2 ? '72%' : '86%'} height={11} style={{ display:'block', marginTop:8 }}/>
      </div>
    ))}
  </div>
);

const ExportRuleDetailSkeleton = () => (
  <div className="export-rule-detail export-rule-detail-skeleton" aria-label="Loading export destination details" role="status">
    <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, padding:16 }}>
      <SkeletonPill width={84} height={10} style={{ display:'block', borderRadius:4, marginBottom:10 }}/>
      <div style={{ display:'grid', gridTemplateColumns:'34px minmax(0, 1fr)', gap:10, alignItems:'center' }}>
        <SkeletonPill width={34} height={34} style={{ borderRadius:7 }}/>
        <SkeletonPill width="62%" height={42} style={{ borderRadius:7 }}/>
      </div>
      <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginTop:14 }}>
        <SkeletonPill width={122} height={18}/>
        <SkeletonPill width={156} height={18}/>
      </div>
    </div>

    <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, padding:16 }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}>
        <SkeletonPill width={15} height={15} style={{ borderRadius:4 }}/>
        <SkeletonPill width={220} height={13}/>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:16 }}>
        {[0, 1].map(idx => (
          <div key={idx} style={{ border:'1px solid #F3F4F6', borderRadius:8, padding:13, minHeight:86 }}>
            <SkeletonPill width={idx ? 132 : 118} height={13} style={{ display:'block', marginBottom:10 }}/>
            <SkeletonPill width={42} height={22} style={{ display:'block', marginBottom:9 }}/>
            <SkeletonPill width="84%" height={11} style={{ display:'block' }}/>
          </div>
        ))}
      </div>
      <SkeletonPill width="100%" height={36} style={{ display:'block', borderRadius:8, marginTop:12 }}/>
    </div>

    <div style={{ marginTop:-6, padding:'0 2px' }}>
      <SkeletonPill width={180} height={11}/>
    </div>

    <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden' }}>
      <div style={{ padding:'14px 18px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
        <div style={{ minWidth:220, flex:1 }}>
          <SkeletonPill width={86} height={13} style={{ display:'block', marginBottom:8 }}/>
          <SkeletonPill width="68%" height={12} style={{ display:'block' }}/>
        </div>
        <SkeletonPill width={300} height={44} style={{ borderRadius:8, maxWidth:'100%' }}/>
      </div>
      <SkeletonPill width="100%" height={40} style={{ display:'block', borderRadius:0 }}/>
    </div>

    <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden' }}>
      <div style={{ padding:'14px 18px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
        <div style={{ minWidth:220, flex:1 }}>
          <SkeletonPill width={112} height={13} style={{ display:'block', marginBottom:8 }}/>
          <SkeletonPill width="58%" height={12} style={{ display:'block' }}/>
        </div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          <SkeletonPill width={112} height={32} style={{ borderRadius:8 }}/>
          <SkeletonPill width={120} height={32} style={{ borderRadius:8 }}/>
        </div>
      </div>
      <div style={{ padding:14, display:'grid', gap:12 }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:8 }}>
          {[0, 1, 2].map(idx => (
            <div key={idx} style={{ border:'1px solid #F3F4F6', borderRadius:8, padding:11 }}>
              <SkeletonPill width={idx === 0 ? 126 : 94} height={13} style={{ display:'block', marginBottom:9 }}/>
              <SkeletonPill width="82%" height={11} style={{ display:'block' }}/>
            </div>
          ))}
        </div>
        <SkeletonPill width="100%" height={126} style={{ display:'block', borderRadius:8 }}/>
      </div>
    </div>
  </div>
);

const ExportRulesLoadErrorPanel = ({ onRetry }) => (
  <div style={{ minHeight:520, background:'#fff', border:'1px solid #FCA5A5', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', padding:28 }}>
    <div style={{ textAlign:'center', maxWidth:390 }}>
      <AlertTriangle size={34} strokeWidth={1.8} color="#DC2626"/>
      <div style={{ fontSize:16, fontWeight:900, color:'#1A1A2E', marginTop:12 }}>Destinations could not load</div>
      <div style={{ fontSize:13, color:'#6B7280', lineHeight:1.45, marginTop:5 }}>Your saved destinations were not cleared. Retry once the connection is back.</div>
      <button onClick={onRetry} style={{ marginTop:14, background:'#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'9px 12px', fontSize:13, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
        <RefreshCw size={14}/>Retry
      </button>
    </div>
  </div>
);

const ExportInvoiceBatchModal = ({ rule, includeFulfilled = false, onClose, onNavigate, onComplete }) => {
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [profile, setProfile] = useState(null);
  const [orders, setOrders] = useState([]);
  const [skipped, setSkipped] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().slice(0, 10));
  const [shipment, setShipment] = useState({
    waybill:'',
    packageCount:1,
    reasonExport:COMMERCIAL_INVOICE_REASON_OPTIONS[0],
    incoterm:'',
    freightStatement:'',
  });
  const [error, setError] = useState('');
  const firstSkippedNeedsOrderValue = skipped[0]?.issues?.some(issue => String(issue).includes('positive order value'));

  useEffect(() => {
    let active = true;
    Promise.all([
      api('GET', '/api/invoice-settings'),
      api('GET', `/api/export-rules/${rule.id}/invoices/preview?includeFulfilled=${includeFulfilled ? '1' : '0'}`),
    ]).then(([settingsResult, previewResult]) => {
      if (!active) return;
      if (!settingsResult.ok) throw new Error(settingsResult.data?.error || 'Could not load invoice settings.');
      if (!previewResult.ok) throw new Error(previewResult.data?.error || 'Could not load assigned orders.');
      const nextProfile = settingsResult.data?.settings || {};
      const nextOrders = previewResult.data?.orders || [];
      setProfile(nextProfile);
      setOrders(nextOrders);
      setShipment(current => ({
        ...current,
        reasonExport:nextProfile.defaultReasonExport || COMMERCIAL_INVOICE_REASON_OPTIONS[0],
        incoterm:nextProfile.defaultIncoterm || '',
        freightStatement:nextProfile.defaultFreightStatement || '',
      }));
      setSkipped(previewResult.data?.skipped || []);
      setLoading(false);
    }).catch(err => {
      if (!active) return;
      setError(err?.message || 'Could not prepare invoice exports.');
      setLoading(false);
    });
    return () => { active = false; };
  }, [rule.id, includeFulfilled]);

  const updateShipment = (key, value) => {
    setShipment(current => ({ ...current, [key]:value }));
    setError('');
  };
  const openSettings = () => {
    try { sessionStorage.setItem('omnifill_settings_page', 'invoices'); } catch {}
    onClose();
    onNavigate?.('settings');
  };
  const generate = async () => {
    if (!profile?.businessName?.trim() || !profile?.address?.trim() || !profile?.eori?.trim()) {
      setError('Complete the seller name, address, and EORI in Invoice settings first.');
      return;
    }
    if (!orders.length) {
      setError('No assigned orders have complete invoice data.');
      return;
    }
    const preparedOrders = [];
    for (const invoice of orders) {
      const invoiceShipment = {
        ...invoice.shipment,
        ...shipment,
        items:invoice.shipment.items,
      };
      const validation = validateCommercialInvoiceDraft({
        profile,
        order:invoice.order,
        invoiceNumber:invoice.invoiceNumber,
        invoiceDate,
        shipment:invoiceShipment,
      });
      if (validation.error) {
        setError(`${invoice.orderId}: ${validation.error}`);
        return;
      }
      preparedOrders.push({
        ...invoice,
        invoiceDate,
        shipment:{ ...invoiceShipment, grossWeightKg:validation.grossWeightKg },
      });
    }
    setGenerating(true);
    setError('');
    try {
      const [logoData, signatureData] = await Promise.all([
        invoiceImageForPdf(profile.logoData),
        invoiceImageForPdf(profile.signatureData),
      ]);
      const response = await fetch(`/api/export-rules/${rule.id}/invoices`, {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        credentials:'same-origin',
        body:JSON.stringify({
          profileImages:{ logoData, signatureData },
          orders:preparedOrders,
          includeFulfilled,
        }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data?.error || 'Could not generate invoice ZIP.');
      }
      const blob = await response.blob();
      const disposition = response.headers.get('content-disposition') || '';
      const filename = disposition.match(/filename="([^"]+)"/i)?.[1] || `omnifill-invoices-${rule.id}.zip`;
      const invoiceCount = Number(response.headers.get('x-omnifill-invoice-count') || orders.length);
      const skippedCount = Number(response.headers.get('x-omnifill-skipped-count') || skipped.length);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      onComplete?.(invoiceCount, skippedCount);
      onClose();
    } catch (err) {
      setError(err?.message || 'Could not generate invoice ZIP.');
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.48)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10020, padding:18 }} onClick={onClose}>
      <div style={{ width:940, maxWidth:'100%', maxHeight:'calc(100vh - 36px)', overflow:'auto', background:'#fff', border:'1px solid #E5E7EB', borderRadius:14, boxShadow:'0 24px 70px rgba(15,23,42,0.24)' }} onClick={event => event.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, padding:'18px 20px', borderBottom:'1px solid #F3F4F6' }}>
          <div>
            <div style={{ fontSize:16, fontWeight:900, color:'#1A1A2E' }}>Prepare invoice PDFs</div>
            <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>{rule.name || rule.destination}. Each valid order becomes a separate PDF in one ZIP.</div>
          </div>
          <button onClick={onClose} title="Close" style={{ width:32, height:32, border:'1px solid #E5E7EB', borderRadius:8, background:'#F9FAFB', color:'#374151', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}><X size={15}/></button>
        </div>
        <div style={{ padding:'18px 20px', display:'grid', gap:14 }}>
          {loading ? (
            <>
              <SkeletonPill width="100%" height={74} style={{ borderRadius:8 }}/>
              <SkeletonPill width="100%" height={180} style={{ borderRadius:8 }}/>
            </>
          ) : (
            <>
              {profile?.businessName && profile?.address ? (
                <div style={{ display:'flex', alignItems:'center', gap:12, background:'#F8FAFC', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 12px' }}>
                  {profile.logoData && <img src={profile.logoData} alt="" style={{ width:82, height:52, objectFit:'contain', flexShrink:0 }}/>}
                  <div style={{ minWidth:0 }}>
                    <div style={{ fontSize:12, fontWeight:900, color:'#1A1A2E' }}>{profile.businessName}</div>
                    <div style={{ fontSize:11, color:'#6B7280', whiteSpace:'pre-line', marginTop:2 }}>{profile.address}</div>
                  </div>
                  <button type="button" onClick={openSettings} style={{ marginLeft:'auto', background:'#fff', border:'1px solid #D1D5DB', color:'#374151', borderRadius:8, padding:'7px 9px', fontSize:12, fontWeight:800, cursor:'pointer', flexShrink:0 }}>Edit invoice settings</button>
                </div>
              ) : (
                <div style={{ background:'#FFFBEB', border:'1px solid #FDE68A', borderRadius:8, padding:'10px 12px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
                  <div style={{ fontSize:12, color:'#92400E' }}>Add the seller name, address, EORI, and optional logo before generating invoices.</div>
                  <button type="button" onClick={openSettings} style={{ background:'#fff', border:'1px solid #F59E0B', color:'#92400E', borderRadius:8, padding:'7px 9px', fontSize:12, fontWeight:800, cursor:'pointer', whiteSpace:'nowrap' }}>Open settings</button>
                </div>
              )}

              <div style={{ border:'1px solid #E5E7EB', borderRadius:9, overflow:'hidden' }}>
                <div style={{ padding:'10px 12px', background:'#F8FAFC', borderBottom:'1px solid #E5E7EB' }}>
                  <div style={{ fontSize:12, fontWeight:900, color:'#1A1A2E' }}>Invoices for {orders.length} assigned order{orders.length === 1 ? '' : 's'}</div>
                  <div style={{ fontSize:11, color:'#6B7280', marginTop:2 }}>These values apply to every invoice. Invoice numbers remain unique and use each Omnifill order ID.</div>
                </div>
                <div style={{ padding:12, display:'grid', gap:12 }}>
                  <label style={{ fontSize:11, fontWeight:800, color:'#6B7280', maxWidth:260 }}>Invoice date
                    <input type="date" value={invoiceDate} onChange={event => { setInvoiceDate(event.target.value); setError(''); }} style={{ width:'100%', border:'1px solid #E5E7EB', borderRadius:8, padding:'8px 10px', fontSize:13, outline:'none', background:'#fff', color:'#1A1A2E', marginTop:5 }}/>
                  </label>
                  <CommercialInvoiceShipmentFields order={null} shipment={shipment} onShipmentChange={updateShipment}/>
                  <div style={{ fontSize:11, color:'#6B7280', lineHeight:1.45 }}>
                    Net and gross weights are calculated from each order's product quantities. Update product weights in Products, not in this invoice step.
                  </div>
                </div>
              </div>

              {!!skipped.length && (
                <div style={{ border:'1px solid #FDE68A', background:'#FFFBEB', color:'#92400E', borderRadius:8, padding:'9px 11px', fontSize:11, lineHeight:1.45, display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
                  <span>{skipped.length} incomplete order{skipped.length === 1 ? '' : 's'} will be skipped. {skipped[0].orderId} needs {skipped[0].issues.join(', ')}.</span>
                  <button type="button" onClick={() => { onClose(); onNavigate?.(firstSkippedNeedsOrderValue ? 'orders' : 'products'); }} style={{ background:'#fff', border:'1px solid #F59E0B', color:'#92400E', borderRadius:8, padding:'6px 9px', fontSize:11, fontWeight:900, cursor:'pointer', whiteSpace:'nowrap' }}>
                    {firstSkippedNeedsOrderValue ? 'Open Orders' : 'Open Products'}
                  </button>
                </div>
              )}
              {error && <div style={{ fontSize:12, color:'#B91C1C', fontWeight:700 }}>{error}</div>}
              <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
                <button onClick={onClose} disabled={generating} style={{ background:'#F3F4F6', border:'1px solid #E5E7EB', color:'#374151', borderRadius:8, padding:'8px 13px', fontSize:13, fontWeight:700, cursor:generating ? 'not-allowed' : 'pointer' }}>Cancel</button>
                <button onClick={generate} disabled={generating || !orders.length || !profile?.businessName || !profile?.address} style={{ background:generating || !orders.length || !profile?.businessName || !profile?.address ? '#D1D5DB' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 13px', fontSize:13, fontWeight:900, cursor:generating || !orders.length || !profile?.businessName || !profile?.address ? 'not-allowed' : 'pointer', display:'inline-flex', alignItems:'center', gap:6 }}>
                  <Download size={14}/>{generating ? 'Creating ZIP...' : `Download ${orders.length} invoice PDF${orders.length === 1 ? '' : 's'}`}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const ExportScreen = ({ orders = [], products = [], ordersLoading = false, onOrdersChanged, onNavigate }) => {
  const [rules, setRules] = useState([]);
  const [fields, setFields] = useState(EXPORT_FIELD_DEFS.map(f => ({ key:f.key, label:f.label })));
  const [selectedId, setSelectedId] = useState(null);
  const [form, setForm] = useState(() => ({ ...EXPORT_RULE_INITIAL, criteria:{ ...EXPORT_RULE_INITIAL.criteria }, mapping:[...EXPORT_RULE_INITIAL.mapping] }));
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [creating, setCreating] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [createError, setCreateError] = useState('');
  const [picker, setPicker] = useState(null);
  const [routingAdvancedOpen, setRoutingAdvancedOpen] = useState(false);
  const [profilePickerOpen, setProfilePickerOpen] = useState(false);
  const [csvManualOpen, setCsvManualOpen] = useState(false);
  const [csvFormats, setCsvFormats] = useState([]);
  const [csvFormatsLoading, setCsvFormatsLoading] = useState(true);
  const [csvFormatSaving, setCsvFormatSaving] = useState(false);
  const [csvFormatName, setCsvFormatName] = useState('');
  const [csvFormatError, setCsvFormatError] = useState('');
  const [sftpOpen, setSftpOpen] = useState(false);
  const [sftpLoading, setSftpLoading] = useState(false);
  const [sftpSaving, setSftpSaving] = useState(false);
  const [sftpConfig, setSftpConfig] = useState(null);
  const [sftpForm, setSftpForm] = useState({ host:'', port:22, username:'', password:'', privateKey:'', passphrase:'', remotePath:'/inbound/orders', filePrefix:'omnifill_orders', autoPush:false });
  const [dcixOpen, setDcixOpen] = useState(false);
  const [dcixLoading, setDcixLoading] = useState(false);
  const [dcixSaving, setDcixSaving] = useState(false);
  const [dcixConfig, setDcixConfig] = useState(null);
  const [dcixForm, setDcixForm] = useState({ baseUrl:'', system:'', userName:'', password:'', authenticationKey:'', deviceIdentifier:'', orderDefinitionName:'salesOrder', orderState:'Released', companyCode:'', locationCode:'', fromWarehouseCode:'', toWarehouseCode:'', sourceName:'Omnifill', autoPush:false });
  const [shipbobOpen, setShipbobOpen] = useState(false);
  const [shipbobLoading, setShipbobLoading] = useState(false);
  const [shipbobSaving, setShipbobSaving] = useState(false);
  const [shipbobConfig, setShipbobConfig] = useState(null);
  const [shipbobForm, setShipbobForm] = useState({ token:'', channelId:'', shippingMethod:'Standard', orderType:'DTC', locationId:'', autoPush:false });
  const [logsRefreshKey, setLogsRefreshKey] = useState(0);
  const [activityOpen, setActivityOpen] = useState(false);
  const [deliveryFocus, setDeliveryFocus] = useState('none');
  const [methodCatalogOpen, setMethodCatalogOpen] = useState(false);
  const [methodSearch, setMethodSearch] = useState('');
  const [profileSearch, setProfileSearch] = useState('');
  const [countrySearch, setCountrySearch] = useState('');
  const [usStatesOpen, setUsStatesOpen] = useState(false);
  const [openCountryGroups, setOpenCountryGroups] = useState({});
  const [timelineOpen, setTimelineOpen] = useState(false);
  const [invoiceBatchOpen, setInvoiceBatchOpen] = useState(false);
  const [csvIncludeFulfilled, setCsvIncludeFulfilled] = useState(false);
  const [invoiceIncludeFulfilled, setInvoiceIncludeFulfilled] = useState(false);

  const sourceOptions = Array.from(new Set([...SOURCE_TAB_SOURCE_IDS, ...orders.map(o => o.source).filter(Boolean)]));
  const countryOptions = ALL_COUNTRIES.map(country => country.code);
  const fulfillableProducts = products;
  const fulfillableProductIds = fulfillableProducts.map(p => p.id);
  const selectedRule = rules.find(r => r.id === selectedId) || null;
  const isAllOrdersDestination = selectedRule?.criteria?.allOrders === true;
  const timelineBounds = exportDateBounds(form.criteria);
  const timelineSummary = form.criteria.datePreset === 'today'
    ? 'Today'
    : form.criteria.datePreset === 'last7'
    ? 'Last 7 days'
    : form.criteria.datePreset === 'last30'
    ? 'Last 30 days'
    : form.criteria.datePreset === 'custom'
    ? `${timelineBounds.from || 'Any date'} to ${timelineBounds.to || 'Today'}`
    : 'All time';
  const effectiveCsvIncludeFulfilled = csvIncludeFulfilled || form.criteria.includeFulfilled === true;
  const effectiveInvoiceIncludeFulfilled = invoiceIncludeFulfilled || form.criteria.includeFulfilled === true;
  const exportCsvAssignedCount = effectiveCsvIncludeFulfilled
    ? selectedRule?.matchCountIncludingFulfilled || 0
    : selectedRule?.matchCount || 0;
  const exportInvoiceMatchedCount = effectiveInvoiceIncludeFulfilled
    ? selectedRule?.invoiceMatchedCountIncludingFulfilled || 0
    : selectedRule?.invoiceMatchedCount || 0;
  const exportInvoiceReadyCount = effectiveInvoiceIncludeFulfilled
    ? selectedRule?.invoiceReadyCountIncludingFulfilled || 0
    : selectedRule?.invoiceReadyCount || 0;
  const exportInvoiceSkippedCount = effectiveInvoiceIncludeFulfilled
    ? selectedRule?.invoiceSkippedCountIncludingFulfilled || 0
    : selectedRule?.invoiceSkippedCount || 0;
  const exportInvoiceSkippedPreview = effectiveInvoiceIncludeFulfilled
    ? selectedRule?.invoiceSkippedPreviewIncludingFulfilled || []
    : selectedRule?.invoiceSkippedPreview || [];
  const editing = !!selectedRule;
  const initialRulesLoading = loading && rules.length === 0;
  const createDisabled = creating || loading || (!!loadError && rules.length === 0);
  const sftpConfigured = !!sftpConfig?.connection;
  const dcixConfigured = !!dcixConfig?.connection;
  const shipbobConfigured = !!shipbobConfig?.connection;
  const methodIdForRule = rule => {
    if (!rule) return 'none';
    if (rule.shipbobAutoPush || rule.shipbobConnectionId) return 'shipbob';
    if (rule.dcixAutoPush || rule.dcixConnectionId) return 'dcix';
    if (rule.sftpAutoPush || rule.sftpConnectionId) return 'sftp';
    return 'none';
  };
  const inputStyle = { width:'100%', border:'1px solid #E5E7EB', borderRadius:7, padding:'8px 10px', fontSize:13, outline:'none', background:'#fff', color:'#1A1A2E' };
  const labelStyle = { display:'block', fontSize:10, fontWeight:800, color:'#9CA3AF', letterSpacing:'0.08em', marginBottom:6 };
  const refreshRuleLogs = () => setLogsRefreshKey(key => key + 1);
  const loadRules = useCallback(async (preferredId = null, opts = {}) => {
    const silent = !!opts.silent;
    if (!silent) {
      setLoading(true);
      setLoadError('');
    }
    try {
      const { ok, data } = await api('GET', '/api/export-rules');
      if (ok) {
        const nextRules = data.rules || [];
        setRules(nextRules);
        if (data.fields?.length) setFields(data.fields);
        const nextSelected = preferredId ? nextRules.find(rule => rule.id === preferredId) : null;
        if (nextSelected) {
          setSelectedId(nextSelected.id);
          if (!opts.preserveForm) setForm(ruleToForm(nextSelected));
        } else if (!preferredId) {
          const firstRule = nextRules[0] || null;
          setSelectedId(firstRule?.id || null);
          if (firstRule && !opts.preserveForm) {
            setForm(ruleToForm(firstRule));
          }
        }
      } else if (!silent) {
        setLoadError(data?.error || 'Could not load destinations. Your saved destinations were not cleared.');
      }
    } catch {
      if (!silent) setLoadError('Could not load destinations. Your saved destinations were not cleared.');
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  const loadCsvFormats = useCallback(async () => {
    setCsvFormatsLoading(true);
    const { ok, data } = await api('GET', '/api/csv-export-formats');
    if (ok) setCsvFormats(data.formats || []);
    else setCsvFormatError(data?.error || 'Could not load saved CSV formats.');
    setCsvFormatsLoading(false);
  }, []);

  useEffect(() => { loadRules(null); }, []);
  useEffect(() => { loadCsvFormats(); }, []);

  useEffect(() => {
    if (!selectedRule) return;
    setDeliveryFocus(methodIdForRule(selectedRule));
    setMethodCatalogOpen(false);
    setMethodSearch('');
  }, [selectedId]);

  useEffect(() => {
    const includeFulfilled = selectedRule?.criteria?.includeFulfilled === true;
    setCsvIncludeFulfilled(includeFulfilled);
    setInvoiceIncludeFulfilled(includeFulfilled);
  }, [selectedId, selectedRule?.criteria?.includeFulfilled]);

  const ruleToForm = rule => ({
    name: rule.destination || rule.name || '',
    destination: rule.name || rule.destination || '',
    active: true,
    criteria: {
      allOrders: rule.criteria?.allOrders === true,
      productIds: rule.criteria?.productIds || [],
      sources: rule.criteria?.sources || [],
      countries: rule.criteria?.countries || [],
      states: rule.criteria?.states || [],
      paidOnly: rule.criteria?.paidOnly !== false,
      excludeRouted: rule.criteria?.excludeRouted !== false,
      includeFulfilled: rule.criteria?.includeFulfilled === true,
      datePreset: ['today', 'last7', 'last30', 'custom'].includes(rule.criteria?.datePreset) ? rule.criteria.datePreset : '',
      dateFrom: rule.criteria?.dateFrom || '',
      dateTo: rule.criteria?.dateTo || '',
      minQuantity: rule.criteria?.minQuantity ?? '',
      maxQuantity: rule.criteria?.maxQuantity ?? '',
      requireProduct: rule.criteria?.requireProduct === true,
      requireShippingAddress: rule.criteria?.requireShippingAddress === true,
    },
    mapping: rule.mapping?.length ? rule.mapping : EXPORT_RULE_INITIAL.mapping,
  });

  const ruleToPayload = (rule, overrides = {}) => {
    const nextRule = {
      ...rule,
      ...overrides,
      criteria:{ ...(rule.criteria || {}), ...(overrides.criteria || {}) },
      mapping:overrides.mapping || rule.mapping || EXPORT_RULE_INITIAL.mapping,
    };
    const destination = String(nextRule.destination || nextRule.name || 'Custom 3PL').trim() || 'Custom 3PL';
    return {
      name:String(nextRule.name || destination).trim() || destination,
      destination,
      active: true,
      criteria: nextRule.criteria || EXPORT_RULE_INITIAL.criteria,
      mapping: nextRule.mapping?.length ? nextRule.mapping : EXPORT_RULE_INITIAL.mapping,
    };
  };

  const nextUnnamedRuleName = () => {
    const used = new Set(rules.map(rule => String(rule.name || rule.destination || '').trim()));
    let n = 1;
    while (used.has(`Destination #${n}`)) n += 1;
    return `Destination #${n}`;
  };

  const startNew = async () => {
    setCreating(true);
    setCreateError('');
    setMessage('');
    const name = nextUnnamedRuleName();
    const payload = {
      name,
      destination: name,
      active: true,
      criteria: EXPORT_RULE_INITIAL.criteria,
      mapping: EXPORT_RULE_INITIAL.mapping,
    };
    const { ok, data } = await api('POST', '/api/export-rules', payload);
    setCreating(false);
    if (!ok) {
      setCreateError(data?.error || 'Could not create destination.');
      return;
    }
    const created = data.rule;
    setRules(prev => [created, ...prev.filter(rule => rule.id !== created.id)]);
    setSelectedId(created.id);
    setForm(ruleToForm(created));
    setActivityOpen(false);
    await loadRules(created.id, { silent:true });
  };

  const selectRule = rule => {
    setSelectedId(rule.id);
    setForm(ruleToForm(rule));
    setActivityOpen(false);
    setError('');
    setMessage('');
  };

  const setCriteria = patch => setForm(f => ({ ...f, criteria:{ ...f.criteria, ...patch } }));
  const toggleArray = (key, value) => {
    const current = form.criteria[key] || [];
    setCriteria({ [key]: current.includes(value) ? current.filter(v => v !== value) : [...current, value] });
  };
  const setMappingRow = (idx, patch) => setForm(f => ({ ...f, mapping:f.mapping.map((row, i) => i === idx ? { ...row, ...patch } : row) }));
  const addMappingRow = () => {
    setCsvManualOpen(true);
    setForm(f => ({ ...f, mapping:[...f.mapping, { header:'', field:'order_id' }] }));
  };
  const removeMappingRow = idx => setForm(f => ({ ...f, mapping:f.mapping.filter((_, i) => i !== idx) }));
  const moveMappingRow = (idx, direction) => {
    setForm(f => {
      const next = [...f.mapping];
      const target = idx + direction;
      if (target < 0 || target >= next.length) return f;
      [next[idx], next[target]] = [next[target], next[idx]];
      return { ...f, mapping: next };
    });
  };
  const profileToMapping = profile => profile.mapping.map(([header, field]) => ({ header, field }));
  const profileSearchQuery = profileSearch.trim().toLowerCase();
  const visibleProfiles = EXPORT_PROFILES.filter(profile => {
    if (!profileSearchQuery) return true;
    return [profile.name, profile.partner, profile.mode, profile.region, profile.cadence]
      .some(value => String(value || '').toLowerCase().includes(profileSearchQuery));
  });
  const visibleCsvFormats = csvFormats.filter(format => !profileSearchQuery || format.name.toLowerCase().includes(profileSearchQuery));
  const applyExportProfile = id => {
    const profile = EXPORT_PROFILES.find(p => p.id === id);
    if (!profile) return;
    setForm(f => ({
      ...f,
      destination: (!f.destination || /^Destination #\d+$/.test(f.destination) || /^Unnamed Rule #\d+$/.test(f.destination)) ? profile.partner : f.destination,
      name: (!f.destination || /^Destination #\d+$/.test(f.destination) || /^Unnamed Rule #\d+$/.test(f.destination)) ? profile.partner : f.name,
      mapping: profileToMapping(profile),
    }));
  };
  const chooseExportProfile = id => {
    applyExportProfile(id);
    setProfilePickerOpen(false);
    setCsvManualOpen(false);
    setProfileSearch('');
  };
  const chooseCsvFormat = format => {
    setForm(current => ({ ...current, mapping:format.mapping.map(row => ({ ...row })) }));
    setCsvFormatName(format.name);
    setProfilePickerOpen(false);
    setCsvManualOpen(false);
    setProfileSearch('');
    setCsvFormatError('');
  };
  const saveCsvFormat = async () => {
    const name = csvFormatName.trim();
    if (!name) {
      setCsvFormatError('Enter a name for this CSV format.');
      return;
    }
    setCsvFormatSaving(true);
    setCsvFormatError('');
    const { ok, data } = await api('POST', '/api/csv-export-formats', { name, mapping:form.mapping });
    setCsvFormatSaving(false);
    if (!ok) {
      setCsvFormatError(data?.error || 'Could not save CSV format.');
      return;
    }
    const saved = data.format;
    setCsvFormats(current => [saved, ...current.filter(format => format.id !== saved.id)]);
    setCsvFormatName(saved.name);
    setMessage(data.updated ? `CSV format "${saved.name}" updated.` : `CSV format "${saved.name}" saved.`);
  };
  const deleteCsvFormat = async format => {
    if (!confirm(`Delete CSV format "${format.name}"? Destinations already using it will not change.`)) return;
    const { ok, data } = await api('DELETE', `/api/csv-export-formats/${format.id}`);
    if (!ok) {
      setCsvFormatError(data?.error || 'Could not delete CSV format.');
      return;
    }
    setCsvFormats(current => current.filter(item => item.id !== format.id));
    if (csvFormatName.toLowerCase() === format.name.toLowerCase()) setCsvFormatName('');
  };
  const mappingsEqual = profile => {
    if (!profile || profile.mapping.length !== form.mapping.length) return false;
    return profile.mapping.every(([header, field], idx) => form.mapping[idx]?.header === header && form.mapping[idx]?.field === field);
  };
  const selectedProfile = EXPORT_PROFILES.find(profile => mappingsEqual(profile)) || null;
  const selectedCsvFormat = csvFormats.find(format =>
    format.mapping.length === form.mapping.length
    && format.mapping.every((row, idx) => form.mapping[idx]?.header === row.header && form.mapping[idx]?.field === row.field)
  ) || null;

  const matchingOrders = orders.filter(order => {
    const status = normalizeDashboardOrderStatus(order.status);
    const c = form.criteria;
    const items = orderItemsForDisplay(order);
    const qty = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0) || Number(order.qty || 0);
    const minQuantity = Number(c.minQuantity);
    const maxQuantity = Number(c.maxQuantity);
    if (status === 'ignored') return false;
    if (!orderMatchesExportDate(order, c)) return false;
    if (c.allOrders === true) return items.length > 0;
    if (c.paidOnly && status !== 'paid') return false;
    if (c.excludeRouted && status === 'routed') return false;
    if (c.productIds.includes(NO_PRODUCTS_SELECTED)) return false;
    if (c.productIds.length && !items.some(item => c.productIds.map(Number).includes(Number(item.product_id)))) return false;
    if (c.sources.includes(NO_SOURCES_SELECTED)) return false;
    if (c.sources.length && !c.sources.includes(order.source)) return false;
    if (c.countries.includes(NO_COUNTRIES_SELECTED)) return false;
    if (c.countries.length && !c.countries.includes(String(order.country || '').toUpperCase())) return false;
    if (Array.isArray(c.states) && c.states.includes(NO_US_STATES_SELECTED) && String(order.country || '').toUpperCase() === 'US') return false;
    if (Array.isArray(c.states) && c.states.length && !c.states.includes(NO_US_STATES_SELECTED) && String(order.country || '').toUpperCase() === 'US' && !c.states.includes(normalizeUsStateCode(order.state))) return false;
    if (Number.isFinite(minQuantity) && minQuantity > 0 && qty < minQuantity) return false;
    if (Number.isFinite(maxQuantity) && maxQuantity > 0 && qty > maxQuantity) return false;
    if (c.requireProduct && !items.every(item => item.product_id)) return false;
    if (c.requireShippingAddress && ![order.first_name || order.last_name, order.address_line1, order.city, order.postal_code, order.country].every(value => String(value || '').trim())) return false;
    return items.length > 0;
  });

  const buildRulePayload = (overrides = {}) => {
    const nextForm = {
      ...form,
      ...overrides,
      criteria:{ ...form.criteria, ...(overrides.criteria || {}) },
      mapping:overrides.mapping || form.mapping,
    };
    return {
      name: nextForm.destination,
      destination: nextForm.destination,
      active: true,
      criteria: nextForm.criteria,
      mapping: nextForm.mapping,
    };
  };

  const saveRule = async (overrides = {}, successMessage = 'Destination saved.') => {
    setSaving(true);
    setError('');
    setMessage('');
    const payload = buildRulePayload(overrides);
    const path = editing ? `/api/export-rules/${selectedId}` : '/api/export-rules';
    const { ok, data } = await api(editing ? 'PATCH' : 'POST', path, payload);
    setSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not save destination.');
      return false;
    }
    setMessage(successMessage);
    setSelectedId(data.rule.id);
    await loadRules(data.rule.id);
    return true;
  };

  const deleteRule = async () => {
    if (!selectedId || !confirm('Delete this destination?')) return;
    const { ok } = await api('DELETE', `/api/export-rules/${selectedId}`);
    if (ok) {
      setSelectedId(null);
      setForm({ ...EXPORT_RULE_INITIAL, criteria:{ ...EXPORT_RULE_INITIAL.criteria }, mapping:[...EXPORT_RULE_INITIAL.mapping] });
      setActivityOpen(false);
      setError('');
      setMessage('');
      await loadRules(null);
    }
  };

  const downloadRuleCsv = async () => {
    if (!selectedId) return;
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/csv`, { markRouted:true, includeFulfilled:effectiveCsvIncludeFulfilled });
    if (!ok) {
      setError(data?.error || 'Could not generate CSV.');
      return;
    }
    const blob = new Blob([data.csv || ''], { type:'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = data.filename || `omnifill-export-${selectedId}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    setMessage(`${data.rowCount || 0} order${data.rowCount === 1 ? '' : 's'} exported.`);
    refreshRuleLogs();
    onOrdersChanged?.();
    await loadRules(selectedId);
  };

  const openInvoiceSettings = () => {
    try { sessionStorage.setItem('omnifill_settings_page', 'invoices'); } catch {}
    onNavigate?.('settings');
  };

  const loadSftpConfig = useCallback(async (ruleId = selectedId) => {
    if (!ruleId) return;
    setSftpLoading(true);
    const { ok, data } = await api('GET', `/api/export-rules/${ruleId}/sftp`);
    setSftpLoading(false);
    if (!ok) return;
    setSftpConfig(data);
    setSftpForm(f => ({
      ...f,
      host:data.connection?.host || '',
      port:data.connection?.port || 22,
      username:data.connection?.username || '',
      password:'',
      privateKey:'',
      passphrase:'',
      remotePath:data.connection?.remotePath || '/inbound/orders',
      filePrefix:data.connection?.filePrefix || 'omnifill_orders',
      autoPush:!!data.autoPush,
    }));
  }, [selectedId]);

  useEffect(() => {
    if (selectedId) loadSftpConfig(selectedId);
    else setSftpConfig(null);
  }, [selectedId, loadSftpConfig]);

  const saveSftpConfig = async () => {
    if (!selectedId) return;
    setSftpSaving(true);
    setError('');
    setMessage('');
    const payload = {
      host:sftpForm.host,
      port:sftpForm.port,
      username:sftpForm.username,
      password:sftpForm.password,
      privateKey:sftpForm.privateKey,
      passphrase:sftpForm.passphrase,
      remotePath:sftpForm.remotePath,
      filePrefix:sftpForm.filePrefix,
      autoPush:sftpForm.autoPush,
    };
    const { ok, data } = await api('PUT', `/api/export-rules/${selectedId}/sftp`, payload);
    setSftpSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not save SFTP settings.');
      return;
    }
    setMessage('SFTP settings saved.');
    setSftpOpen(false);
    await loadSftpConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const testSftpConfig = async () => {
    if (!selectedId) return;
    setSftpSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/sftp/test`, {});
    setSftpSaving(false);
    if (!ok) {
      setError(data?.error || 'SFTP test failed.');
      await loadSftpConfig(selectedId);
      return;
    }
    setMessage(data?.message || 'SFTP connection succeeded.');
    await loadSftpConfig(selectedId);
  };

  const pingSftpConfig = async () => {
    if (!selectedId) return;
    setSftpSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/sftp/ping`, {});
    setSftpSaving(false);
    if (!ok) {
      setError(data?.error || 'SFTP test ping failed.');
      await loadSftpConfig(selectedId);
      return;
    }
    setMessage(data?.message || 'SFTP test ping delivered.');
    refreshRuleLogs();
    await loadSftpConfig(selectedId);
  };

  const pushSftpNow = async () => {
    if (!selectedId) return;
    setSftpSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/sftp/send`, { markRouted:true });
    setSftpSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not push orders to SFTP.');
      return;
    }
    setMessage(data.skipped ? 'No matching paid orders to push.' : `${data.rowCount || 0} order${data.rowCount === 1 ? '' : 's'} pushed to SFTP.`);
    refreshRuleLogs();
    onOrdersChanged?.();
    await loadSftpConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const toggleSftpAutoPush = async checked => {
    if (!selectedId) return;
    setSftpForm(f => ({ ...f, autoPush:checked }));
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/sftp/auto-push`, { enabled:checked });
    if (!ok) {
      setError(data?.error || 'Configure SFTP before enabling auto-push.');
      setSftpForm(f => ({ ...f, autoPush:!checked }));
      return;
    }
    await loadSftpConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const loadShipbobConfig = useCallback(async (ruleId = selectedId) => {
    if (!ruleId) return;
    setShipbobLoading(true);
    const { ok, data } = await api('GET', `/api/export-rules/${ruleId}/shipbob`);
    setShipbobLoading(false);
    if (!ok) return;
    setShipbobConfig(data);
    setShipbobForm(f => ({
      ...f,
      token:'',
      channelId:data.connection?.channelId || '',
      shippingMethod:data.connection?.shippingMethod || 'Standard',
      orderType:data.connection?.orderType || 'DTC',
      locationId:data.connection?.locationId || '',
      autoPush:!!data.autoPush,
    }));
  }, [selectedId]);

  useEffect(() => {
    if (selectedId) loadShipbobConfig(selectedId);
    else setShipbobConfig(null);
  }, [selectedId, loadShipbobConfig]);

  const saveShipbobConfig = async () => {
    if (!selectedId) return;
    setShipbobSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('PUT', `/api/export-rules/${selectedId}/shipbob`, shipbobForm);
    setShipbobSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not save ShipBob settings.');
      return;
    }
    setMessage('ShipBob settings saved.');
    setShipbobOpen(false);
    await loadShipbobConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const testShipbobConfig = async () => {
    if (!selectedId) return;
    setShipbobSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/shipbob/test`, {});
    setShipbobSaving(false);
    if (!ok) {
      setError(data?.error || 'ShipBob test failed.');
      await loadShipbobConfig(selectedId);
      return;
    }
    setMessage(data?.message || 'ShipBob connection succeeded.');
    await loadShipbobConfig(selectedId);
  };

  const pingShipbobConfig = async () => {
    if (!selectedId) return;
    setShipbobSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/shipbob/ping`, {});
    setShipbobSaving(false);
    if (!ok) {
      setError(data?.error || 'ShipBob test ping failed.');
      await loadShipbobConfig(selectedId);
      return;
    }
    const refText = data?.externalRef ? ` Reference: ${data.externalRef}.` : '';
    setMessage(`${data?.message || 'ShipBob test ping succeeded.'}${refText}`);
    refreshRuleLogs();
    await loadShipbobConfig(selectedId);
  };

  const pushShipbobNow = async () => {
    if (!selectedId) return;
    setShipbobSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/shipbob/send`, { markRouted:true });
    setShipbobSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not send orders to ShipBob.');
      return;
    }
    setMessage(data.skipped ? 'No matching paid orders to send.' : `${data.rowCount || 0} order${data.rowCount === 1 ? '' : 's'} sent to ShipBob.`);
    refreshRuleLogs();
    onOrdersChanged?.();
    await loadShipbobConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const toggleShipbobAutoPush = async checked => {
    if (!selectedId) return;
    setShipbobForm(f => ({ ...f, autoPush:checked }));
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/shipbob/auto-push`, { enabled:checked });
    if (!ok) {
      setError(data?.error || 'Configure ShipBob before enabling auto-send.');
      setShipbobForm(f => ({ ...f, autoPush:!checked }));
      return;
    }
    await loadShipbobConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const loadDcixConfig = useCallback(async (ruleId = selectedId) => {
    if (!ruleId) return;
    setDcixLoading(true);
    const { ok, data } = await api('GET', `/api/export-rules/${ruleId}/dcix`);
    setDcixLoading(false);
    if (!ok) return;
    setDcixConfig(data);
    setDcixForm(f => ({
      ...f,
      baseUrl:data.connection?.baseUrl || '',
      system:data.connection?.system || '',
      userName:'',
      password:'',
      authenticationKey:'',
      deviceIdentifier:'',
      orderDefinitionName:data.connection?.orderDefinitionName || 'salesOrder',
      orderState:data.connection?.orderState || 'Released',
      companyCode:data.connection?.companyCode || '',
      locationCode:data.connection?.locationCode || '',
      fromWarehouseCode:data.connection?.fromWarehouseCode || '',
      toWarehouseCode:data.connection?.toWarehouseCode || '',
      sourceName:data.connection?.sourceName || 'Omnifill',
      autoPush:!!data.autoPush,
    }));
  }, [selectedId]);

  useEffect(() => {
    if (selectedId) loadDcixConfig(selectedId);
    else setDcixConfig(null);
  }, [selectedId, loadDcixConfig]);

  const saveDcixConfig = async () => {
    if (!selectedId) return;
    setDcixSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('PUT', `/api/export-rules/${selectedId}/dcix`, dcixForm);
    setDcixSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not save DCIx settings.');
      return;
    }
    setMessage('DCIx settings saved.');
    setDcixOpen(false);
    await loadDcixConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const testDcixConfig = async () => {
    if (!selectedId) return;
    setDcixSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/dcix/test`, {});
    setDcixSaving(false);
    if (!ok) {
      setError(data?.error || 'DCIx test failed.');
      await loadDcixConfig(selectedId);
      return;
    }
    setMessage(data?.message || 'DCIx login succeeded.');
    await loadDcixConfig(selectedId);
  };

  const pingDcixConfig = async () => {
    if (!selectedId) return;
    setDcixSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/dcix/ping`, {});
    setDcixSaving(false);
    if (!ok) {
      setError(data?.error || 'DCIx test ping failed.');
      await loadDcixConfig(selectedId);
      return;
    }
    const refText = data?.externalRef ? ` Reference: ${data.externalRef}.` : '';
    setMessage(`${data?.message || 'DCIx test ping succeeded.'}${refText}`);
    refreshRuleLogs();
    await loadDcixConfig(selectedId);
  };

  const pushDcixNow = async () => {
    if (!selectedId) return;
    setDcixSaving(true);
    setError('');
    setMessage('');
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/dcix/send`, { markRouted:true });
    setDcixSaving(false);
    if (!ok) {
      setError(data?.error || 'Could not send orders to DCIx.');
      return;
    }
    const requestText = data.requestID ? ` Request ID: ${data.requestID}.` : '';
    setMessage(data.skipped ? 'No matching paid orders to send.' : `${data.rowCount || 0} order${data.rowCount === 1 ? '' : 's'} sent to DCIx.${requestText}`);
    refreshRuleLogs();
    onOrdersChanged?.();
    await loadDcixConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const toggleDcixAutoPush = async checked => {
    if (!selectedId) return;
    setDcixForm(f => ({ ...f, autoPush:checked }));
    const { ok, data } = await api('POST', `/api/export-rules/${selectedId}/dcix/auto-push`, { enabled:checked });
    if (!ok) {
      setError(data?.error || 'Configure DCIx before enabling auto-send.');
      setDcixForm(f => ({ ...f, autoPush:!checked }));
      return;
    }
    await loadDcixConfig(selectedId);
    await loadRules(selectedId, { silent:true });
  };

  const productLabel = id => {
    const product = products.find(p => Number(p.id) === Number(id));
    return product ? `${product.name}${product.sku ? ` (${product.sku})` : ''}` : `Product ${id}`;
  };
  const sourceLabel = source => source === 'manual' ? 'Manual import' : (PLATFORM_CFG[source]?.label || source);
  const countryLabel = code => ALL_COUNTRIES.find(country => country.code === code)?.name || code;
  const selectedSummary = (items, emptyLabel, labelFn = v => v) => {
    if (!items?.length) return emptyLabel;
    if (items.length <= 2) return items.map(labelFn).join(', ');
    return `${items.slice(0, 2).map(labelFn).join(', ')} +${items.length - 2}`;
  };
  const explicitProducts = () => form.criteria.productIds.includes(NO_PRODUCTS_SELECTED)
    ? []
    : form.criteria.productIds.length
    ? form.criteria.productIds.filter(id => fulfillableProductIds.map(Number).includes(Number(id)))
    : fulfillableProductIds;
  const setProducts = ids => {
    const fulfillable = new Set(fulfillableProductIds.map(Number));
    const clean = Array.from(new Set(ids)).filter(id => fulfillable.has(Number(id)));
    setCriteria({ productIds: clean.length === fulfillableProductIds.length ? [] : clean.length === 0 ? [NO_PRODUCTS_SELECTED] : clean });
  };
  const productSelected = id => explicitProducts().map(Number).includes(Number(id));
  const toggleProduct = id => {
    const current = explicitProducts();
    setProducts(productSelected(id) ? current.filter(value => Number(value) !== Number(id)) : [...current, id]);
  };
  const selectedProductSummary = () => {
    if (form.criteria.productIds.includes(NO_PRODUCTS_SELECTED)) return 'No products';
    if (form.criteria.productIds.length && explicitProducts().length === 0) return 'No products';
    if (!form.criteria.productIds.length) return 'All products';
    return selectedSummary(explicitProducts(), 'All products', productLabel);
  };
  const explicitCountries = () => form.criteria.countries.includes(NO_COUNTRIES_SELECTED) ? [] : form.criteria.countries.length ? form.criteria.countries : ALL_COUNTRY_CODES;
  const setCountries = codes => {
    const clean = Array.from(new Set(codes)).filter(code => ALL_COUNTRY_CODES.includes(code));
    setCriteria({ countries: clean.length === ALL_COUNTRY_CODES.length ? [] : clean.length === 0 ? [NO_COUNTRIES_SELECTED] : clean });
  };
  const countrySelected = code => explicitCountries().includes(code);
  const toggleCountry = code => {
    const current = explicitCountries();
    setCountries(current.includes(code) ? current.filter(c => c !== code) : [...current, code]);
  };
  const countryShortcutState = shortcut => {
    const selected = new Set(explicitCountries());
    const hits = shortcut.codes.filter(code => selected.has(code)).length;
    return hits === shortcut.codes.length ? 'all' : hits > 0 ? 'some' : 'none';
  };
  const countryCodesState = codes => {
    const selected = new Set(explicitCountries());
    const hits = codes.filter(code => selected.has(code)).length;
    return hits === codes.length ? 'all' : hits > 0 ? 'some' : 'none';
  };
  const countryShortcutSummary = shortcut => {
    const selected = new Set(explicitCountries());
    const hits = shortcut.codes.filter(code => selected.has(code)).length;
    return `${hits} of ${shortcut.codes.length}`;
  };
  const toggleCountryShortcut = shortcut => {
    if (!form.criteria.countries.length) {
      setCountries(shortcut.codes);
      return;
    }
    toggleCountryCodes(shortcut.codes);
  };
  const toggleCountryCodes = codes => {
    const state = countryCodesState(codes);
    const current = explicitCountries();
    setCountries(state === 'all' ? current.filter(code => !codes.includes(code)) : [...current, ...codes]);
  };
  const explicitUsStates = () => Array.isArray(form.criteria.states) && form.criteria.states.includes(NO_US_STATES_SELECTED) ? [] : Array.isArray(form.criteria.states) && form.criteria.states.length ? form.criteria.states : ALL_US_STATE_CODES;
  const setUsStates = codes => {
    const clean = Array.from(new Set(codes.map(normalizeUsStateCode))).filter(code => ALL_US_STATE_CODES.includes(code));
    setCriteria({ states: clean.length === ALL_US_STATE_CODES.length ? [] : clean.length === 0 ? [NO_US_STATES_SELECTED] : clean });
  };
  const usStateSelected = code => explicitUsStates().includes(code);
  const usStateCodesState = codes => {
    const selected = new Set(explicitUsStates());
    const hits = codes.filter(code => selected.has(code)).length;
    return hits === codes.length ? 'all' : hits > 0 ? 'some' : 'none';
  };
  const toggleUsStateCodes = codes => {
    const state = usStateCodesState(codes);
    const current = explicitUsStates();
    setUsStates(state === 'all' ? current.filter(code => !codes.includes(code)) : [...current, ...codes]);
  };
  const selectedUsStateSummary = () => {
    if (Array.isArray(form.criteria.states) && form.criteria.states.includes(NO_US_STATES_SELECTED)) return 'No US states';
    if (!Array.isArray(form.criteria.states) || !form.criteria.states.length) return 'All US states';
    return selectedSummary(form.criteria.states, 'All US states', code => code);
  };
  const selectedDestinationSummary = () => {
    const countrySummary = form.criteria.countries.includes(NO_COUNTRIES_SELECTED)
      ? 'No countries'
      : form.criteria.countries.length
      ? selectedSummary(form.criteria.countries, 'All countries', code => `${countryLabel(code)} (${code})`)
      : 'All countries';
    return countrySelected('US') && Array.isArray(form.criteria.states) && form.criteria.states.length
      ? `${countrySummary}; ${selectedUsStateSummary()}`
      : countrySummary;
  };
  const explicitSources = () => form.criteria.sources.includes(NO_SOURCES_SELECTED) ? [] : form.criteria.sources.length ? form.criteria.sources : sourceOptions;
  const setSources = values => {
    const clean = Array.from(new Set(values)).filter(value => sourceOptions.includes(value));
    setCriteria({ sources: clean.length === sourceOptions.length ? [] : clean.length === 0 ? [NO_SOURCES_SELECTED] : clean });
  };
  const sourceSelected = source => explicitSources().includes(source);
  const toggleSource = source => {
    const current = explicitSources();
    setSources(current.includes(source) ? current.filter(value => value !== source) : [...current, source]);
  };
  const advancedActiveCount = [
    form.criteria.sources?.includes(NO_SOURCES_SELECTED) || form.criteria.sources?.length,
    form.criteria.minQuantity,
    form.criteria.maxQuantity,
    form.criteria.requireProduct,
    form.criteria.requireShippingAddress,
  ].filter(Boolean).length;
  const currentMissingAddressCount = matchingOrders.filter(order => ![
    [order.first_name, order.last_name].filter(Boolean).join(' '),
    order.address_line1,
    order.city,
    order.postal_code,
    order.country,
  ].every(value => String(value || '').trim())).length;
  const currentMissingSkuCount = matchingOrders.filter(order => orderItemsForDisplay(order).some(item => !String(item.display_sku || item.product_sku || item.sku || '').trim())).length;
  const selectedMethodNeedsSku = ['shipbob', 'dcix'].includes(deliveryFocus);
  const selectedMethodNeedsAddress = ['shipbob', 'dcix', 'sftp'].includes(deliveryFocus);
  const deliverySummaryForRule = rule => {
    if (rule.shipbobAutoPush) return 'ShipBob API auto-send';
    if (rule.dcixAutoPush) return 'DCIx API auto-send';
    if (rule.sftpAutoPush) return 'SFTP auto-push';
    if (rule.shipbobConnectionId) return 'ShipBob API ready';
    if (rule.dcixConnectionId) return 'DCIx API ready';
    if (rule.sftpConnectionId) return 'SFTP ready';
    return 'No automatic send';
  };
  const methodStatus = id => {
    if (id === 'none') return { configured:false, auto:false, label:'None', detail:'No automatic send method selected.', tone:'#6B7280', bg:'#F3F4F6' };
    if (id === 'sftp') return {
      configured:sftpConfigured,
      auto:!!sftpConfig?.autoPush,
      label:sftpConfigured ? (sftpConfig?.autoPush ? 'Auto-push on' : 'Ready') : 'Needs setup',
      detail:sftpConfigured ? `Host: ${sftpConfig.connection.host}` : 'Upload CSV files to a warehouse folder.',
      tone:sftpConfigured ? '#166534' : '#6B7280',
      bg:sftpConfigured ? '#DCFCE7' : '#F3F4F6',
    };
    if (id === 'shipbob') return {
      configured:shipbobConfigured,
      auto:!!shipbobConfig?.autoPush,
      label:shipbobConfigured ? (shipbobConfig?.autoPush ? 'Auto-send on' : 'Ready') : 'Needs setup',
      detail:shipbobConfigured ? `Channel ${shipbobConfig.connection.channelId}` : 'Create orders directly in ShipBob.',
      tone:shipbobConfigured ? '#166534' : '#6B7280',
      bg:shipbobConfigured ? '#DCFCE7' : '#F3F4F6',
    };
    if (id === 'dcix') return {
      configured:dcixConfigured,
      auto:!!dcixConfig?.autoPush,
      label:dcixConfigured ? (dcixConfig?.autoPush ? 'Auto-send on' : 'Ready') : 'Needs setup',
      detail:dcixConfigured ? `System ${dcixConfig.connection.system}` : 'Send directly to your warehouse API.',
      tone:dcixConfigured ? '#166534' : '#6B7280',
      bg:dcixConfigured ? '#DCFCE7' : '#F3F4F6',
    };
    return { configured:false, auto:false, label:'Planned', detail:'Not available yet.', tone:'#6B7280', bg:'#F3F4F6' };
  };
  const deliveryMethods = [
    { id:'none', name:'None', category:'Automatic sending', Icon:XCircle, available:true, description:'No automatic send method selected.', keywords:'none off disabled automatic' },
    { id:'sftp', name:'SFTP upload', category:'File push', Icon:Upload, available:true, description:'Push CSV files to an inbound warehouse folder.', keywords:'sftp upload push file folder warehouse csv' },
    { id:'shipbob', name:'ShipBob API', category:'Warehouse API', Icon:Truck, available:true, description:'Send matching orders directly to ShipBob with product SKUs as reference IDs.', keywords:'shipbob api warehouse 3pl wms fulfillment' },
    { id:'dcix', name:'DCIx WMS API', category:'Warehouse API', Icon:Truck, available:true, description:'Send matching orders into the configured WMS connection.', keywords:'dcix wms api warehouse fulfillment' },
  ];
  const automaticMethodOptions = deliveryMethods.filter(method => method.id !== 'none');
  const methodSearchQuery = methodSearch.trim().toLowerCase();
  const visibleDeliveryMethods = automaticMethodOptions.filter(method => !methodSearchQuery || [method.name, method.category, method.description, method.keywords].some(value => String(value || '').toLowerCase().includes(methodSearchQuery)));
  const showComingSoonMethod = true;
  const focusedMethod = deliveryMethods.find(method => method.id === deliveryFocus) || deliveryMethods[0];
  const focusedMethodStatus = methodStatus(focusedMethod.id);
  const selectDeliveryMethod = method => {
    if (!method.available) return;
    setDeliveryFocus(method.id);
    setMethodCatalogOpen(false);
    setMethodSearch('');
  };
  const requestSendMethodSupport = () => {
    const draft = {
      category:'Export / 3PL',
      subject:'Request a new export send method',
      message:[
        'I would like Omnifill to support a new way to send orders.',
        '',
        'Warehouse or platform:',
        'How they accept orders:',
        'CSV template, API docs, or setup notes:',
        'Expected order volume:',
      ].join('\n'),
    };
    try { sessionStorage.setItem('omnifill_support_draft', JSON.stringify(draft)); } catch {}
    if (onNavigate) onNavigate('support');
    else window.location.href = '/support';
  };
  const AdvancedCheckbox = ({ checked, onChange, title, sub }) => (
    <label style={{ display:'flex', gap:9, alignItems:'flex-start', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 11px', cursor:'pointer', background:checked ? '#F0F6FF' : '#fff' }}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{ marginTop:2, flexShrink:0 }}/>
      <span style={{ minWidth:0 }}>
        <span style={{ display:'block', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>{title}</span>
        <span style={{ display:'block', fontSize:11, color:'#9CA3AF', lineHeight:1.35, marginTop:2 }}>{sub}</span>
      </span>
    </label>
  );
  const RuleActivityPanel = ({ ruleId, ruleName, refreshKey, limit = 300, modal = false, onClose }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [logError, setLogError] = useState('');
    const providerLabels = { csv:'CSV', sftp:'SFTP', dcix:'DCIx', shipbob:'ShipBob', gmail:'Gmail' };
    const statusMeta = {
      success: { label:'Success', color:'#166534', bg:'#DCFCE7', Icon:CheckCircle2 },
      error: { label:'Error', color:'#991B1B', bg:'#FEE2E2', Icon:XCircle },
      skipped: { label:'Skipped', color:'#374151', bg:'#F3F4F6', Icon:Clock3 },
    };
    const loadLogs = useCallback(async () => {
      if (!ruleId) return;
      setLoading(true);
      setLogError('');
      const { ok, data } = await api('GET', `/api/fulfillment-logs?ruleId=${ruleId}&limit=${limit}`);
      setLoading(false);
      if (!ok) {
        setLogError(data?.error || 'Could not load export activity.');
        return;
      }
      setLogs(data.logs || []);
    }, [ruleId, limit]);
    useEffect(() => { loadLogs(); }, [loadLogs, refreshKey]);
    const formatLogTime = value => {
      if (!value) return 'Unknown';
      const date = new Date(`${value}Z`);
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString([], { dateStyle:'medium', timeStyle:'short' });
    };
    const StatusBadge = ({ status }) => {
      const meta = statusMeta[status] || statusMeta.skipped;
      const Icon = meta.Icon;
      return <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'3px 7px', borderRadius:5, background:meta.bg, color:meta.color, fontSize:11, fontWeight:900 }}><Icon size={12}/>{meta.label}</span>;
    };
    return (
      <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden', ...(modal ? { width:'min(980px, 100%)', maxHeight:'min(760px, calc(100vh - 32px))', display:'flex', flexDirection:'column', boxShadow:'0 24px 70px rgba(0,0,0,0.2)' } : {}) }}>
        <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
          <div>
            <div style={{ fontSize:13, fontWeight:900, color:'#1A1A2E' }}>Activity</div>
            <div style={{ fontSize:11, color:'#6B7280', marginTop:2 }}>{ruleName || 'Selected destination'} activity: CSV downloads, test pings, and warehouse deliveries.</div>
          </div>
          <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
            <button onClick={loadLogs} disabled={loading} style={{ background:'#fff', color:loading ? '#9CA3AF' : '#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'7px 10px', fontSize:12, fontWeight:900, cursor:loading ? 'wait' : 'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
              <RefreshCw size={13}/>{loading ? 'Loading...' : 'Refresh'}
            </button>
            {onClose && (
              <button onClick={onClose} title="Close activity" style={{ width:32, height:32, background:'#F9FAFB', color:'#374151', border:'1px solid #E5E7EB', borderRadius:8, cursor:'pointer', display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
                <X size={14}/>
              </button>
            )}
          </div>
        </div>
        {logError && <div style={{ padding:'9px 14px', borderBottom:'1px solid #FEE2E2', background:'#FEF2F2', color:'#991B1B', fontSize:12, fontWeight:800 }}>{logError}</div>}
        <div style={{ overflow:'auto', minHeight:0, ...(modal ? { flex:1 } : {}) }}>
          <table style={{ width:'100%', minWidth:760, borderCollapse:'collapse', fontSize:12 }}>
            <thead><tr style={{ background:'#F9FAFB', borderBottom:'1px solid #E5E7EB' }}>{['Time','Status','Delivery','Orders','Reference','Message'].map(header => <th key={header} style={{ textAlign:'left', padding:'9px 12px', color:'#6B7280', fontSize:11, fontWeight:900 }}>{header}</th>)}</tr></thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" style={{ padding:14, color:'#9CA3AF' }}>Loading export activity...</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan="6" style={{ padding:14, color:'#9CA3AF' }}>No export activity for this destination yet.</td></tr>
              ) : logs.map(log => (
                <tr key={log.id} style={{ borderBottom:'1px solid #F3F4F6' }}>
                  <td style={{ padding:'9px 12px', color:'#374151', whiteSpace:'nowrap' }}>{formatLogTime(log.createdAt)}</td>
                  <td style={{ padding:'9px 12px' }}><StatusBadge status={log.status}/></td>
                  <td style={{ padding:'9px 12px', color:'#1A1A2E', fontWeight:900 }}>{providerLabels[log.provider] || log.provider}</td>
                  <td style={{ padding:'9px 12px', color:'#374151' }}><span style={{ fontWeight:900 }}>{log.rowCount || 0}</span>{log.orderIds?.length > 0 && <span title={log.orderIds.join(', ')} style={{ marginLeft:5, color:'#9CA3AF' }}>({log.orderIds.slice(0, 2).join(', ')}{log.orderIds.length > 2 ? ` +${log.orderIds.length - 2}` : ''})</span>}</td>
                  <td style={{ padding:'9px 12px', color:'#6B7280', fontFamily:'monospace', fontSize:11, maxWidth:170, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={log.externalRef}>{log.externalRef || '-'}</td>
                  <td style={{ padding:'9px 12px', color:log.status === 'error' ? '#991B1B' : '#6B7280', maxWidth:260, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={log.message}>{log.message || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  const RuleActivityModal = () => {
    if (!activityOpen || !selectedRule) return null;
    return (
      <div className="export-rule-confirm-overlay" onClick={() => setActivityOpen(false)}>
        <div role="dialog" aria-modal="true" aria-label="Destination activity" onClick={e => e.stopPropagation()} style={{ width:'min(980px, 100%)' }}>
          <RuleActivityPanel
            ruleId={selectedId}
            ruleName={selectedRule?.name || selectedRule?.destination}
            refreshKey={logsRefreshKey}
            limit={300}
            modal
            onClose={() => setActivityOpen(false)}
          />
        </div>
      </div>
    );
  };
  const AdvancedNumberInput = ({ label, value, onChange, placeholder }) => (
    <label style={{ display:'grid', gap:6, minWidth:0 }}>
      <span style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', letterSpacing:'0.06em', textTransform:'uppercase' }}>{label}</span>
      <input type="number" min="0" step="any" value={value ?? ''} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={{ ...inputStyle, height:36 }}/>
    </label>
  );
  const pickerConfig = {
    products: {
      title:'Products / SKUs',
      empty:products.length ? 'No fulfillable products to export.' : 'Create products first to export by SKU.',
      selected:explicitProducts(),
      selectedLabel:form.criteria.productIds.includes(NO_PRODUCTS_SELECTED) ? 'No products selected' : (form.criteria.productIds.length ? `${explicitProducts().length} selected` : 'All will match'),
      options:fulfillableProducts.map(p => ({ value:p.id, label:p.name || 'Untitled product', sku:p.sku || 'No SKU', image:p.image_data })),
      toggle:value => toggleProduct(value),
      selectAll:() => setProducts(fulfillableProductIds),
      clear:() => setProducts([]),
      renderOption:option => (
        <>
          <ProductThumb src={option.image} size={30}/>
          <span style={{ minWidth:0, display:'grid', gridTemplateColumns:'minmax(0, 1fr) auto', gap:8, alignItems:'baseline', flex:1 }}>
            <span style={{ minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{option.label}</span>
            <span style={{ color:'#9CA3AF', fontSize:12, fontWeight:800, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{option.sku}</span>
          </span>
        </>
      ),
    },
    sources: {
      title:'Sources',
      empty:'No order sources yet.',
      selected:explicitSources(),
      options:sourceOptions.map(source => ({ value:source, label:sourceLabel(source) })),
      toggle:value => toggleSource(value),
      selectAll:() => setSources(sourceOptions),
      clear:() => setSources([]),
    },
    countries: {
      title:'Countries',
      empty:'No country data yet.',
      selected:explicitCountries(),
      options:countryOptions.map(country => ({ value:country, label:countryLabel(country) })),
      toggle:value => toggleArray('countries', value),
      clear:() => setCriteria({ countries:[] }),
    },
  };
  const ChoiceButton = ({ title, summary, count, valueLabel, onClick }) => (
    <button onClick={onClick} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:9, padding:'12px 13px', textAlign:'left', cursor:'pointer', minWidth:0 }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
        <span style={{ fontSize:12, fontWeight:900, color:'#1A1A2E' }}>{title}</span>
        {count !== undefined && <span style={{ fontSize:11, fontWeight:900, color:count ? '#006FDD' : '#9CA3AF', background:count ? '#EEF6FF' : '#F3F4F6', borderRadius:5, padding:'2px 7px' }}>{count}</span>}
        {valueLabel && <span style={{ fontSize:11, fontWeight:900, color:'#006FDD' }}>{valueLabel}</span>}
      </div>
      <div style={{ marginTop:6, fontSize:12, color:'#6B7280', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{summary}</div>
    </button>
  );
  const StatusChip = ({ status }) => (
    <span style={{ display:'inline-flex', alignItems:'center', gap:5, borderRadius:5, padding:'3px 7px', background:status.bg, color:status.tone, fontSize:11, fontWeight:900, whiteSpace:'nowrap' }}>
      {status.configured ? <CheckCircle2 size={12}/> : <Clock3 size={12}/>}
      {status.label}
    </span>
  );
  const DeliveryMethodCard = ({ method, compact = false }) => {
    const status = methodStatus(method.id);
    const Icon = method.Icon;
    const active = deliveryFocus === method.id;
    return (
      <button
        onClick={() => selectDeliveryMethod(method)}
        disabled={!method.available}
        style={{
          width:'100%',
          background:active ? '#F0F6FF' : '#fff',
          border:`1px solid ${active ? '#BFD9FF' : '#E5E7EB'}`,
          borderRadius:8,
          padding:compact ? '10px 11px' : '12px 13px',
          textAlign:'left',
          cursor:method.available ? 'pointer' : 'not-allowed',
          opacity:method.available ? 1 : 0.62,
          display:'grid',
          gridTemplateColumns:'34px minmax(0, 1fr)',
          gap:10,
          alignItems:'start',
          minHeight:compact ? 72 : 92,
        }}
      >
        <span style={{ width:34, height:34, borderRadius:8, background:active ? '#DCEEFF' : '#F3F4F6', color:active ? '#006FDD' : '#6B7280', display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <Icon size={16}/>
        </span>
        <span style={{ minWidth:0 }}>
          <span style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:8 }}>
            <span style={{ minWidth:0, fontSize:13, fontWeight:900, color:'#1A1A2E', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{method.name}</span>
            {method.available ? <StatusChip status={status}/> : <span style={{ borderRadius:5, padding:'3px 7px', background:'#F3F4F6', color:'#6B7280', fontSize:11, fontWeight:900, whiteSpace:'nowrap' }}>Planned</span>}
          </span>
          <span style={{ display:'block', marginTop:5, fontSize:11, fontWeight:800, color:'#9CA3AF' }}>{method.category}</span>
          <span style={{ display:'block', marginTop:4, fontSize:12, color:'#6B7280', lineHeight:1.35 }}>{method.available ? status.detail : method.description}</span>
        </span>
      </button>
    );
  };
  const MethodCatalogModal = () => {
    if (!methodCatalogOpen) return null;
    return (
      <div onClick={() => setMethodCatalogOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(920px, 100%)', maxHeight:'min(760px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><Search size={16} color="#006FDD"/>Automatic Sending Method</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Choose how Omnifill should auto-send matching orders after imports or source syncs.</div>
            </div>
            <button onClick={() => setMethodCatalogOpen(false)} title="Close" style={{ width:32, height:32, border:'1px solid #E5E7EB', borderRadius:8, background:'#F9FAFB', color:'#374151', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}><X size={15}/></button>
          </div>
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #F3F4F6' }}>
            <div style={{ position:'relative' }}>
              <Search size={14} color="#9CA3AF" style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }}/>
              <input value={methodSearch} onChange={e => setMethodSearch(e.target.value)} placeholder="Search SFTP, ShipBob, DCIx, WMS API" autoFocus style={{ ...inputStyle, paddingLeft:31, height:38 }}/>
            </div>
          </div>
          <div style={{ flex:1, minHeight:0, overflow:'auto', padding:16, display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(270px, 1fr))', gap:10, alignContent:'start' }}>
            {visibleDeliveryMethods.map(method => <DeliveryMethodCard key={method.id} method={method}/>)}
            {showComingSoonMethod && (
              <div style={{ background:'#fff', border:'1px dashed #CBD5E1', borderRadius:8, padding:'13px', display:'grid', gap:9, alignContent:'start', minHeight:116 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ width:34, height:34, borderRadius:8, background:'#F3F4F6', color:'#6B7280', display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><Plus size={16}/></span>
                  <div style={{ minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:900, color:'#1A1A2E' }}>More coming soon</div>
                    <div style={{ fontSize:11, fontWeight:800, color:'#9CA3AF', marginTop:3 }}>Need a specific warehouse or handoff?</div>
                  </div>
                </div>
                <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.4 }}>Tell us how your partner accepts orders and we can review it for the roadmap.</div>
                <button onClick={requestSendMethodSupport} style={{ justifySelf:'start', background:'#EEF6FF', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 10px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
                  <LifeBuoy size={13}/>Request support
                </button>
              </div>
            )}
            {visibleDeliveryMethods.length === 0 && !showComingSoonMethod && (
              <div style={{ gridColumn:'1 / -1', padding:24, textAlign:'center', color:'#9CA3AF', fontSize:13 }}>No automatic sending methods match that search.</div>
            )}
          </div>
        </div>
      </div>
    );
  };
  const ExportProfileLogo = ({ profile, size = 34 }) => {
    const brand = EXPORT_PROFILE_BRANDING[profile.id] || {};
    if (!brand.logo) return <span style={{ width:size * 2.4, height:size, flexShrink:0 }}/>;
    return <img src={brand.logo} alt="" onError={e => { e.currentTarget.style.display = 'none'; }} style={{ width:size * 2.4, height:size, objectFit:'contain', objectPosition:'right center', flexShrink:0 }}/>;
  };
  const CsvProfilePickerModal = () => {
    if (!profilePickerOpen) return null;
    return (
      <div onClick={() => setProfilePickerOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(860px, 100%)', maxHeight:'min(760px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><FileSpreadsheet size={16} color="#006FDD"/>CSV format library</div>
              <div style={{ fontSize:11, color:'#6B7280', marginTop:3 }}>Reuse an ordered column layout across fulfillment destinations.</div>
            </div>
            <button onClick={() => setProfilePickerOpen(false)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #F3F4F6' }}>
            <div style={{ position:'relative' }}>
              <Search size={14} color="#9CA3AF" style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }}/>
              <input value={profileSearch} onChange={e => setProfileSearch(e.target.value)} placeholder="Search saved and prepared formats" autoFocus style={{ ...inputStyle, paddingLeft:31, height:36 }}/>
            </div>
          </div>
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #F3F4F6', background:'#FAFBFC' }}>
            <div style={{ fontSize:11, fontWeight:900, color:'#374151', marginBottom:7 }}>Save current columns</div>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) auto', gap:8 }}>
              <input value={csvFormatName} onChange={e => { setCsvFormatName(e.target.value); setCsvFormatError(''); }} onKeyDown={e => { if (e.key === 'Enter') saveCsvFormat(); }} placeholder="Format name, for example Acme Warehouse" maxLength={80} style={{ ...inputStyle, height:36 }}/>
              <button onClick={saveCsvFormat} disabled={csvFormatSaving || !form.mapping.length} style={{ background:csvFormatSaving ? '#93C5FD' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:csvFormatSaving ? 'wait' : 'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
                <Save size={13}/>{csvFormatSaving ? 'Saving...' : 'Save format'}
              </button>
            </div>
            {csvFormatError && <div style={{ color:'#B91C1C', fontSize:11, fontWeight:700, marginTop:7 }}>{csvFormatError}</div>}
            <div style={{ color:'#9CA3AF', fontSize:10, marginTop:6 }}>Saving with an existing name updates that format. Existing destinations do not change.</div>
          </div>
          <div style={{ flex:1, minHeight:0, overflow:'auto', padding:16, display:'grid', gap:7, alignContent:'start' }}>
            <div style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', letterSpacing:'0.08em', margin:'1px 0 3px' }}>YOUR FORMATS</div>
            {csvFormatsLoading ? (
              <SkeletonPill width="100%" height={52} style={{ borderRadius:8 }}/>
            ) : visibleCsvFormats.length ? visibleCsvFormats.map(format => (
              <div key={format.id} style={{ minHeight:52, background:selectedCsvFormat?.id === format.id ? '#F4F8FF' : '#fff', border:`1px solid ${selectedCsvFormat?.id === format.id ? '#BFD9FF' : '#E5E7EB'}`, borderRadius:8, display:'grid', gridTemplateColumns:'minmax(0, 1fr) auto', alignItems:'center', overflow:'hidden' }}>
                <button onClick={() => chooseCsvFormat(format)} style={{ alignSelf:'stretch', background:'none', border:'none', padding:'9px 13px', textAlign:'left', cursor:'pointer', minWidth:0 }}>
                  <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:13, fontWeight:900, color:'#1A1A2E' }}>{format.name}</span>
                  <span style={{ display:'block', marginTop:4, fontSize:11, color:'#6B7280' }}>{format.mapping.length} column{format.mapping.length === 1 ? '' : 's'}{selectedCsvFormat?.id === format.id ? ' - currently loaded' : ''}</span>
                </button>
                <button onClick={() => deleteCsvFormat(format)} title={`Delete ${format.name}`} style={{ alignSelf:'stretch', width:46, background:'none', color:'#DC2626', border:'none', borderLeft:'1px solid #F3F4F6', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}><Trash2 size={14}/></button>
              </div>
            )) : (
              <div style={{ padding:'12px 13px', border:'1px dashed #D1D5DB', borderRadius:8, color:'#9CA3AF', fontSize:12 }}>{profileSearchQuery ? 'No saved formats match this search.' : 'No saved formats yet. Name the current columns above to reuse them later.'}</div>
            )}
            <div style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', letterSpacing:'0.08em', margin:'12px 0 3px' }}>PREPARED FORMATS</div>
            {visibleProfiles.length === 0 ? (
              <div style={{ padding:16, textAlign:'center', color:'#9CA3AF', fontSize:13 }}>No prepared formats match that search.</div>
            ) : visibleProfiles.map(profile => (
                <button key={profile.id} onClick={() => chooseExportProfile(profile.id)} style={{ minHeight:52, background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, padding:'9px 13px', textAlign:'left', cursor:'pointer', display:'grid', gridTemplateColumns:'minmax(0, 1fr) auto', gap:16, alignItems:'center' }}>
                  <span style={{ minWidth:0 }}>
                    <span style={{ display:'block', minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:13, fontWeight:900, color:'#1A1A2E' }}>{profile.name}</span>
                    <span style={{ display:'block', marginTop:4, fontSize:11, fontWeight:800, color:'#6B7280', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{profile.partner} - {profile.region}</span>
                  </span>
                  <ExportProfileLogo profile={profile} size={30}/>
                </button>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const PickerModal = () => {
    const cfg = pickerConfig[picker];
    if (!cfg) return null;
    if (picker === 'countries') {
      const selectedCount = explicitCountries().length;
      const query = countrySearch.trim().toLowerCase();
      const visibleCountryGroups = COUNTRY_GROUPS.map(group => ({
        ...group,
        countries: group.countries.filter(([code, name]) => !query || code.toLowerCase().includes(query) || name.toLowerCase().includes(query)),
      })).filter(group => group.countries.length);
      const showUsStates = countrySelected('US');
      return (
        <div onClick={() => setPicker(null)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div onClick={e => e.stopPropagation()} style={{ width:'calc(100vw - 48px)', maxWidth:1480, height:'calc(100vh - 48px)', maxHeight:920, background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:900, color:'#1A1A2E' }}>Destination region</div>
                <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Applies to shipping country. {selectedCount} of {ALL_COUNTRY_CODES.length} selected.</div>
              </div>
              <button onClick={() => setPicker(null)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
            </div>
            <div style={{ padding:'12px 16px', borderBottom:'1px solid #F3F4F6', display:'grid', gap:12 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                <div style={{ position:'relative', flex:'1 1 260px', maxWidth:420 }}>
                  <Search size={14} color="#9CA3AF" style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }}/>
                  <input value={countrySearch} onChange={e => setCountrySearch(e.target.value)} placeholder="Search countries or codes" style={{ ...inputStyle, paddingLeft:31, height:34 }}/>
                </div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  <button onClick={() => setCountries(ALL_COUNTRY_CODES)} style={{ background:'#006FDD', color:'#fff', border:'none', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:900, cursor:'pointer' }}>All countries</button>
                  <button onClick={() => setCountries([])} style={{ background:'#fff', color:'#374151', border:'1px solid #E5E7EB', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:800, cursor:'pointer' }}>No countries</button>
                </div>
              </div>
            </div>
            <div style={{ flex:1, minHeight:0, overflow:'auto', padding:16, display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(124px, 1fr))', gap:6, alignContent:'start' }}>
              <div style={{ gridColumn:'1 / -1', display:'grid', gap:8, marginBottom:8 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                  <span style={{ fontSize:11, fontWeight:900, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>Shortcuts</span>
                  <span style={{ height:1, background:'#F3F4F6', flex:1 }}/>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:7, flexWrap:'wrap' }}>
                  {EXPORT_REGION_SHORTCUTS.map(shortcut => {
                    const state = countryShortcutState(shortcut);
                    const active = state === 'all';
                    const partial = state === 'some';
                    return (
                      <button key={shortcut.name} onClick={() => toggleCountryShortcut(shortcut)} title={`${shortcut.name}: ${countryShortcutSummary(shortcut)} selected`} style={{ minHeight:32, border:`1px solid ${active ? '#9EC7FF' : partial ? '#D7E7FF' : '#E5E7EB'}`, borderRadius:7, background:active ? '#F0F6FF' : partial ? '#F8FBFF' : '#fff', color:active ? '#006FDD' : '#374151', padding:'5px 8px', display:'inline-flex', alignItems:'center', gap:7, cursor:'pointer', fontSize:11, fontWeight:900 }}>
                        <img src={`/assets/circle-flags/flags/${shortcut.flag}.svg`} alt="" onError={e => { e.currentTarget.style.display = 'none'; }} style={{ width:17, height:17, borderRadius:'50%', flexShrink:0 }}/>
                        <span>{shortcut.name}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
              {showUsStates && (
                <div style={{ gridColumn:'1 / -1', border:'1px solid #E5E7EB', borderRadius:9, background:'#FAFBFC', padding:12, marginBottom:8 }}>
                  <button onClick={() => setUsStatesOpen(open => !open)} aria-expanded={usStatesOpen} style={{ width:'100%', border:'none', background:'transparent', padding:0, display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, cursor:'pointer', textAlign:'left' }}>
                    <div>
                      <div style={{ fontSize:12, fontWeight:900, color:'#1A1A2E' }}>United States states</div>
                      <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>{explicitUsStates().length} of {ALL_US_STATE_CODES.length} selected. {selectedUsStateSummary()}.</div>
                    </div>
                    <ChevronDown size={16} color="#9CA3AF" style={{ transform:usStatesOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition:'transform 140ms ease', flexShrink:0 }}/>
                  </button>
                  {usStatesOpen && (
                    <div style={{ marginTop:10 }}>
                      <div style={{ display:'flex', justifyContent:'flex-end', gap:8, flexWrap:'wrap', marginBottom:10 }}>
                        <button onClick={() => setUsStates(ALL_US_STATE_CODES)} style={{ background:'#EEF6FF', color:'#006FDD', border:'1px solid #D7E7FF', borderRadius:7, padding:'6px 9px', fontSize:11, fontWeight:900, cursor:'pointer' }}>All states</button>
                        <button onClick={() => setUsStates([])} style={{ background:'#fff', color:'#374151', border:'1px solid #E5E7EB', borderRadius:7, padding:'6px 9px', fontSize:11, fontWeight:800, cursor:'pointer' }}>Clear</button>
                      </div>
                      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(116px, 1fr))', gap:6 }}>
                        {US_STATE_OPTIONS.map(([code, name]) => (
                          <label key={code} title={name} style={{ display:'flex', alignItems:'center', gap:6, minWidth:0, minHeight:28, border:`1px solid ${usStateSelected(code) ? '#BFD9FF' : '#F3F4F6'}`, borderRadius:6, padding:'5px 7px', cursor:'pointer', background:usStateSelected(code) ? '#F0F6FF' : '#fff' }}>
                            <input type="checkbox" checked={usStateSelected(code)} onChange={() => toggleUsStateCodes([code])} style={{ flexShrink:0, width:13, height:13 }}/>
                            <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:11, fontWeight:800, color:'#374151' }}>{name}</span>
                            <span style={{ color:'#9CA3AF', fontSize:9, fontWeight:900, flexShrink:0 }}>{code}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {visibleCountryGroups.length === 0 ? (
                <div style={{ gridColumn:'1 / -1', padding:22, textAlign:'center', color:'#9CA3AF', fontSize:13 }}>No countries match that search.</div>
              ) : visibleCountryGroups.map(group => {
                const visibleCodes = group.countries.map(([code]) => code);
                const state = countryCodesState(visibleCodes);
                const groupOpen = !!query || !!openCountryGroups[group.name];
                return (
                  <React.Fragment key={group.name}>
                    <div style={{ gridColumn:'1 / -1', display:'flex', alignItems:'center', gap:8, marginTop:4, marginBottom:2 }}>
                      <RegionIcon name={group.name} size={22}/>
                      <button
                        onClick={() => toggleCountryCodes(visibleCodes)}
                        title={`${state === 'all' ? 'Clear' : 'Select'} visible ${group.name} countries`}
                        aria-label={`${state === 'all' ? 'Clear' : 'Select'} visible ${group.name} countries`}
                        aria-checked={state === 'some' ? 'mixed' : state === 'all'}
                        role="checkbox"
                        style={{ width:16, height:16, border:`1px solid ${state === 'none' ? '#CBD5E1' : '#78B3FF'}`, borderRadius:4, background:state === 'none' ? '#fff' : '#006FDD', color:'#fff', cursor:'pointer', display:'inline-flex', alignItems:'center', justifyContent:'center', padding:0, flexShrink:0 }}
                      >
                        {state === 'all' ? <Check size={12} strokeWidth={3}/> : state === 'some' ? <span style={{ width:8, height:2, borderRadius:2, background:'#fff' }}/> : null}
                      </button>
                      <span style={{ fontSize:11, fontWeight:900, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>{group.name}</span>
                      <button
                        onClick={() => setOpenCountryGroups(open => ({ ...open, [group.name]:!open[group.name] }))}
                        title={`${groupOpen ? 'Collapse' : 'Expand'} ${group.name}`}
                        aria-expanded={groupOpen}
                        style={{ width:20, height:20, border:'none', background:'transparent', color:'#9CA3AF', cursor:'pointer', display:'inline-flex', alignItems:'center', justifyContent:'center', padding:0, flexShrink:0 }}
                      >
                        <ChevronDown size={15} style={{ transform:groupOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition:'transform 140ms ease' }}/>
                      </button>
                      <span style={{ height:1, background:'#F3F4F6', flex:1 }}/>
                    </div>
                    {groupOpen && group.countries
                      .map(([code, name]) => ({ code, name }))
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(country => (
                        <label key={country.code} title={`${country.name} (${group.name})`} style={{ display:'flex', alignItems:'center', gap:6, minWidth:0, minHeight:28, border:`1px solid ${countrySelected(country.code) ? '#BFD9FF' : '#F3F4F6'}`, borderRadius:6, padding:'5px 7px', cursor:'pointer', background:countrySelected(country.code) ? '#F0F6FF' : '#fff' }}>
                          <input type="checkbox" checked={countrySelected(country.code)} onChange={() => toggleCountry(country.code)} style={{ flexShrink:0, width:13, height:13 }}/>
                          <img src={`/assets/circle-flags/flags/${country.code.toLowerCase()}.svg`} alt="" onError={e => { e.currentTarget.style.display = 'none'; }} style={{ width:16, height:16, borderRadius:'50%', flexShrink:0 }}/>
                          <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:11, fontWeight:800, color:'#374151' }}>{country.name}</span>
                          <span style={{ color:'#9CA3AF', fontSize:9, fontWeight:900, flexShrink:0 }}>{country.code}</span>
                        </label>
                      ))}
                  </React.Fragment>
                );
              })}
            </div>
            <div style={{ padding:'10px 16px', borderTop:'1px solid #F3F4F6', display:'flex', justifyContent:'flex-end' }}>
              <button onClick={() => setPicker(null)} style={{ background:'#1E2433', color:'#fff', border:'none', borderRadius:7, padding:'8px 14px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Done</button>
            </div>
          </div>
        </div>
      );
    }
    if (picker === 'sources') {
      const selectedCount = explicitSources().length;
      return (
        <div onClick={() => setPicker(null)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div onClick={e => e.stopPropagation()} style={{ width:'min(720px, 100%)', maxHeight:'min(560px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:900, color:'#1A1A2E' }}>Sources</div>
                <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>{selectedCount} of {sourceOptions.length} selected</div>
              </div>
              <button onClick={() => setPicker(null)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
            </div>
            <div style={{ padding:'10px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', gap:8, flexWrap:'wrap' }}>
              <button onClick={() => setSources(sourceOptions)} style={{ background:'#006FDD', color:'#fff', border:'none', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Select all</button>
              <button onClick={() => setSources([])} style={{ background:'#fff', color:'#374151', border:'1px solid #E5E7EB', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:800, cursor:'pointer' }}>Clear all</button>
            </div>
            <div style={{ flex:1, minHeight:0, overflow:'auto', padding:16, display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(172px, 1fr))', gap:7, alignContent:'start' }}>
              {EXPORT_SOURCE_GROUPS.map(group => (
                <React.Fragment key={group.name}>
                  <div style={{ gridColumn:'1 / -1', display:'flex', alignItems:'center', gap:8, marginTop:4, marginBottom:2 }}>
                    <span style={{ fontSize:11, fontWeight:900, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>{group.name}</span>
                    <span style={{ height:1, background:'#F3F4F6', flex:1 }}/>
                  </div>
                  {group.sources.filter(source => sourceOptions.includes(source)).map(source => {
                    const cfg = PLATFORM_CFG[source] || { label:source, color:'#6B7280', bg:'#F3F4F6', char:'?' };
                    const selected = sourceSelected(source);
                    return (
                      <label key={source} title={sourceLabel(source)} style={{ display:'flex', alignItems:'center', gap:7, minWidth:0, minHeight:34, border:`1px solid ${selected ? '#BFD9FF' : '#F3F4F6'}`, borderRadius:6, padding:'6px 8px', cursor:'pointer', background:selected ? '#F0F6FF' : '#fff' }}>
                        <input type="checkbox" checked={selected} onChange={() => toggleSource(source)} style={{ flexShrink:0, width:13, height:13 }}/>
                        <span style={{ width:22, height:22, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                          {cfg.logo
                            ? <img src={cfg.logo} alt="" onError={e => { e.currentTarget.style.display = 'none'; }} style={{ width:22, height:22, objectFit:'contain' }}/>
                            : cfg.Icon
                            ? <cfg.Icon size={19} strokeWidth={2.3} color={cfg.color}/>
                            : <span style={{ color:cfg.color, fontSize:11, fontWeight:900 }}>{cfg.char}</span>
                          }
                        </span>
                        <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12, fontWeight:800, color:'#374151' }}>{sourceLabel(source)}</span>
                      </label>
                    );
                  })}
                </React.Fragment>
              ))}
              {sourceOptions.filter(source => !ALL_EXPORT_SOURCES.includes(source)).length > 0 && (
                <React.Fragment>
                  <div style={{ gridColumn:'1 / -1', display:'flex', alignItems:'center', gap:8, marginTop:4, marginBottom:2 }}>
                    <span style={{ fontSize:11, fontWeight:900, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>Other</span>
                    <span style={{ height:1, background:'#F3F4F6', flex:1 }}/>
                  </div>
                  {sourceOptions.filter(source => !ALL_EXPORT_SOURCES.includes(source)).map(source => {
                    const selected = sourceSelected(source);
                    return (
                      <label key={source} title={sourceLabel(source)} style={{ display:'flex', alignItems:'center', gap:7, minWidth:0, minHeight:34, border:`1px solid ${selected ? '#BFD9FF' : '#F3F4F6'}`, borderRadius:6, padding:'6px 8px', cursor:'pointer', background:selected ? '#F0F6FF' : '#fff' }}>
                        <input type="checkbox" checked={selected} onChange={() => toggleSource(source)} style={{ flexShrink:0, width:13, height:13 }}/>
                        <span style={{ width:22, height:22, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><PlatformPill source={source}/></span>
                        <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12, fontWeight:800, color:'#374151' }}>{sourceLabel(source)}</span>
                      </label>
                    );
                  })}
                </React.Fragment>
              )}
            </div>
            <div style={{ padding:'10px 16px', borderTop:'1px solid #F3F4F6', display:'flex', justifyContent:'flex-end' }}>
              <button onClick={() => setPicker(null)} style={{ background:'#1E2433', color:'#fff', border:'none', borderRadius:7, padding:'8px 14px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Done</button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div onClick={() => setPicker(null)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.28)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(520px, 100%)', maxHeight:'min(640px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 20px 60px rgba(0,0,0,0.18)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'15px 18px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
            <div>
              <div style={{ fontSize:15, fontWeight:900 }}>{cfg.title}</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:2 }}>{cfg.selectedLabel || (cfg.selected.length ? `${cfg.selected.length} selected` : 'All will match')}</div>
            </div>
            <button onClick={() => setPicker(null)} style={{ background:'none', border:'none', fontSize:22, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:'10px 14px', borderBottom:'1px solid #F3F4F6', display:'flex', gap:8, flexWrap:'wrap' }}>
            <button onClick={cfg.selectAll} style={{ background:'#006FDD', color:'#fff', border:'none', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Select all</button>
            <button onClick={cfg.clear} style={{ background:'#fff', color:'#374151', border:'1px solid #E5E7EB', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:800, cursor:'pointer' }}>Clear all</button>
          </div>
          <div style={{ padding:14, overflow:'auto', display:'grid', gap:7 }}>
            {cfg.options.length === 0 ? (
              <div style={{ padding:18, fontSize:13, color:'#9CA3AF', textAlign:'center' }}>{cfg.empty}</div>
            ) : cfg.options.map(option => (
              <label key={option.value} style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 10px', border:'1px solid #F3F4F6', borderRadius:8, fontSize:13, color:'#374151', fontWeight:800, cursor:'pointer' }}>
                <input type="checkbox" checked={cfg.selected.map(String).includes(String(option.value))} onChange={() => cfg.toggle(option.value)}/>
                {cfg.renderOption ? cfg.renderOption(option) : <span style={{ minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{option.label}</span>}
              </label>
            ))}
          </div>
          <div style={{ padding:'12px 14px', borderTop:'1px solid #F3F4F6', display:'flex', justifyContent:'space-between', gap:10 }}>
            <span></span>
            <button onClick={() => setPicker(null)} style={{ background:'#1E2433', color:'#fff', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:900, cursor:'pointer' }}>Done</button>
          </div>
        </div>
      </div>
    );
  };

  const TimelineModal = () => {
    if (!timelineOpen) return null;
    return (
      <div onClick={() => setTimelineOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div role="dialog" aria-modal="true" aria-label="Order timeline" onClick={event => event.stopPropagation()} style={{ width:'min(560px, 100%)', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><Clock3 size={16} color="#006FDD"/>Order timeline</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Choose when included orders were placed.</div>
            </div>
            <button onClick={() => setTimelineOpen(false)} title="Close" style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:16, display:'grid', gap:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(2, minmax(0, 1fr))', gap:8 }}>
              {[
                ['', 'All time'],
                ['today', 'Today'],
                ['last7', 'Last 7 days'],
                ['last30', 'Last 30 days'],
              ].map(([value, label]) => {
                const selected = (form.criteria.datePreset || '') === value;
                return <button key={value || 'all'} type="button" onClick={() => setCriteria({ datePreset:value, dateFrom:'', dateTo:'' })} style={{ background:selected ? '#EEF6FF' : '#fff', color:selected ? '#006FDD' : '#374151', border:`1px solid ${selected ? '#9CC8FF' : '#E5E7EB'}`, borderRadius:8, padding:'10px 12px', fontSize:12, fontWeight:900, cursor:'pointer', textAlign:'left' }}>{label}</button>;
              })}
            </div>
            <div style={{ borderTop:'1px solid #F3F4F6', paddingTop:14, display:'grid', gridTemplateColumns:'repeat(2, minmax(0, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:5 }}>
                <span style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', letterSpacing:'0.06em', textTransform:'uppercase' }}>From</span>
                <input type="date" value={timelineBounds.from} max={timelineBounds.to || undefined} onChange={event => setCriteria({ datePreset:'custom', dateFrom:event.target.value, dateTo:timelineBounds.to })} style={{ ...inputStyle, height:38 }}/>
              </label>
              <label style={{ display:'grid', gap:5 }}>
                <span style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', letterSpacing:'0.06em', textTransform:'uppercase' }}>Through</span>
                <input type="date" value={timelineBounds.to} min={timelineBounds.from || undefined} onChange={event => setCriteria({ datePreset:'custom', dateFrom:timelineBounds.from, dateTo:event.target.value })} style={{ ...inputStyle, height:38 }}/>
              </label>
            </div>
            {form.criteria.datePreset === 'custom' && form.criteria.dateFrom && form.criteria.dateTo && form.criteria.dateFrom > form.criteria.dateTo && (
              <div style={{ color:'#B91C1C', fontSize:11, fontWeight:800 }}>The From date must be before or the same as the Through date.</div>
            )}
          </div>
          <div style={{ padding:'10px 16px', borderTop:'1px solid #F3F4F6', display:'flex', justifyContent:'flex-end' }}>
            <button onClick={() => setTimelineOpen(false)} style={{ background:'#1E2433', color:'#fff', border:'none', borderRadius:7, padding:'8px 14px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Done</button>
          </div>
        </div>
      </div>
    );
  };

  const AdvancedSettingsModal = () => {
    if (!routingAdvancedOpen) return null;
    const selectedSourceCount = explicitSources().length;
    return (
      <div onClick={() => setRoutingAdvancedOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(860px, 100%)', maxHeight:'min(760px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><SlidersHorizontal size={16} color="#006FDD"/>Advanced export settings</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Narrow this destination by source, quantity, and data completeness.</div>
            </div>
            <button onClick={() => setRoutingAdvancedOpen(false)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>

          <div style={{ flex:1, minHeight:0, overflow:'auto', padding:16, display:'grid', gap:16 }}>
            <section style={{ display:'grid', gap:10 }}>
              <div style={{ display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:900, color:'#1A1A2E' }}>Sources</div>
                  <div style={{ fontSize:12, color:'#9CA3AF', marginTop:2 }}>{selectedSourceCount} of {sourceOptions.length} selected</div>
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={() => setSources(sourceOptions)} style={{ background:'#006FDD', color:'#fff', border:'none', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Select all</button>
                  <button onClick={() => setSources([])} style={{ background:'#fff', color:'#374151', border:'1px solid #E5E7EB', borderRadius:7, padding:'7px 10px', fontSize:12, fontWeight:800, cursor:'pointer' }}>Clear all</button>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(170px, 1fr))', gap:7 }}>
                {sourceOptions.length === 0 ? (
                  <div style={{ gridColumn:'1 / -1', padding:14, fontSize:12, color:'#9CA3AF', textAlign:'center', border:'1px solid #F3F4F6', borderRadius:8 }}>No order sources yet.</div>
                ) : sourceOptions.map(source => {
                  const cfg = PLATFORM_CFG[source] || { label:source, color:'#6B7280', bg:'#F3F4F6', char:'?' };
                  const selected = sourceSelected(source);
                  return (
                    <label key={source} title={sourceLabel(source)} style={{ display:'flex', alignItems:'center', gap:7, minWidth:0, minHeight:34, border:`1px solid ${selected ? '#BFD9FF' : '#F3F4F6'}`, borderRadius:6, padding:'6px 8px', cursor:'pointer', background:selected ? '#F0F6FF' : '#fff' }}>
                      <input type="checkbox" checked={selected} onChange={() => toggleSource(source)} style={{ flexShrink:0, width:13, height:13 }}/>
                      <span style={{ width:22, height:22, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        {cfg.logo
                          ? <img src={cfg.logo} alt="" onError={e => { e.currentTarget.style.display = 'none'; }} style={{ width:22, height:22, objectFit:'contain' }}/>
                          : cfg.Icon
                          ? <cfg.Icon size={19} strokeWidth={2.3} color={cfg.color}/>
                          : <span style={{ color:cfg.color, fontSize:11, fontWeight:900 }}>{cfg.char}</span>
                        }
                      </span>
                      <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12, fontWeight:800, color:'#374151' }}>{sourceLabel(source)}</span>
                    </label>
                  );
                })}
              </div>
            </section>

            <section style={{ borderTop:'1px solid #F3F4F6', paddingTop:14, display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:12 }}>
              <AdvancedNumberInput label="Minimum quantity" value={form.criteria.minQuantity} placeholder="Any" onChange={value => setCriteria({ minQuantity:value })}/>
              <AdvancedNumberInput label="Maximum quantity" value={form.criteria.maxQuantity} placeholder="No maximum" onChange={value => setCriteria({ maxQuantity:value })}/>
            </section>

            <section style={{ borderTop:'1px solid #F3F4F6', paddingTop:14, display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(230px, 1fr))', gap:10 }}>
              <AdvancedCheckbox checked={form.criteria.requireProduct} onChange={checked => setCriteria({ requireProduct:checked })} title="Require assigned product" sub="Skip unmatched imported rows until they are assigned to a product or SKU."/>
              <AdvancedCheckbox checked={form.criteria.requireShippingAddress} onChange={checked => setCriteria({ requireShippingAddress:checked })} title="Require complete shipping address" sub="Match only orders with recipient, street, city, postal code, and country."/>
            </section>
          </div>

          <div style={{ padding:'10px 16px', borderTop:'1px solid #F3F4F6', display:'flex', justifyContent:'space-between', gap:10, alignItems:'center', flexWrap:'wrap' }}>
            <div style={{ fontSize:12, color:'#6B7280' }}>
              Draft matches {ordersLoading
                ? <SkeletonPill width={34} height={12}/>
                : <strong style={{ color:'#1A1A2E' }}>{matchingOrders.length}</strong>
              } order{!ordersLoading && matchingOrders.length === 1 ? '' : 's'}.
            </div>
            <button onClick={() => setRoutingAdvancedOpen(false)} style={{ background:'#1E2433', color:'#fff', border:'none', borderRadius:7, padding:'8px 14px', fontSize:12, fontWeight:900, cursor:'pointer' }}>Done</button>
          </div>
        </div>
      </div>
    );
  };

  const SftpSettingsModal = () => {
    if (!sftpOpen) return null;
    return (
      <div onClick={() => setSftpOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(720px, 100%)', maxHeight:'min(760px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><Upload size={16} color="#006FDD"/>SFTP upload</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Upload this destination's CSV to your warehouse's inbound folder.</div>
            </div>
            <button onClick={() => setSftpOpen(false)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:16, overflow:'auto', display:'grid', gap:12 }}>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) 110px', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>HOST</span>
                <input value={sftpForm.host} onChange={e => setSftpForm(f => ({ ...f, host:e.target.value }))} placeholder="sftp.warehouse.com" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>PORT</span>
                <input type="number" min="1" max="65535" value={sftpForm.port} onChange={e => setSftpForm(f => ({ ...f, port:e.target.value }))} style={inputStyle}/>
              </label>
            </div>
            <label style={{ display:'grid', gap:6 }}>
              <span style={labelStyle}>LOGIN NAME</span>
              <input value={sftpForm.username} onChange={e => setSftpForm(f => ({ ...f, username:e.target.value }))} placeholder="omnifill_client" style={inputStyle}/>
            </label>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>PASSWORD</span>
                <input type="password" value={sftpForm.password} onChange={e => setSftpForm(f => ({ ...f, password:e.target.value }))} placeholder={sftpConfig?.connection?.hasPassword ? 'Stored, leave blank to keep' : 'Password auth'} style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>PRIVATE KEY PASSPHRASE</span>
                <input type="password" value={sftpForm.passphrase} onChange={e => setSftpForm(f => ({ ...f, passphrase:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
            </div>
            <label style={{ display:'grid', gap:6 }}>
              <span style={labelStyle}>PRIVATE KEY</span>
              <textarea value={sftpForm.privateKey} onChange={e => setSftpForm(f => ({ ...f, privateKey:e.target.value }))} placeholder={sftpConfig?.connection?.hasPrivateKey ? 'Stored, leave blank to keep' : 'Paste OpenSSH private key if the warehouse uses key auth'} style={{ ...inputStyle, minHeight:92, resize:'vertical', fontFamily:'monospace', fontSize:11 }}/>
            </label>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) minmax(0, 1fr)', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>REMOTE FOLDER</span>
                <input value={sftpForm.remotePath} onChange={e => setSftpForm(f => ({ ...f, remotePath:e.target.value }))} placeholder="/inbound/orders" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>FILE PREFIX</span>
                <input value={sftpForm.filePrefix} onChange={e => setSftpForm(f => ({ ...f, filePrefix:e.target.value }))} placeholder="omnifill_orders" style={inputStyle}/>
              </label>
            </div>
            <label style={{ display:'flex', gap:9, alignItems:'flex-start', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 11px', cursor:'pointer', background:sftpForm.autoPush ? '#F0F6FF' : '#fff' }}>
              <input type="checkbox" checked={sftpForm.autoPush} onChange={e => setSftpForm(f => ({ ...f, autoPush:e.target.checked }))} style={{ marginTop:2, flexShrink:0 }}/>
              <span>
                <span style={{ display:'block', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>Auto-push new matching orders</span>
                <span style={{ display:'block', fontSize:11, color:'#6B7280', lineHeight:1.35, marginTop:2 }}>After imports or source syncs, Omnifill uploads matching paid orders and records successful sends.</span>
              </span>
            </label>
          </div>
          <div style={{ padding:'12px 16px', borderTop:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
            <div style={{ fontSize:11, color:'#9CA3AF' }}>{sftpConfig?.connection?.lastTestStatus === 'ok' ? 'Last test succeeded.' : sftpConfig?.connection?.lastTestStatus === 'error' ? 'Last test failed.' : 'Save settings before testing.'}</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', justifyContent:'flex-end' }}>
              <button onClick={testSftpConfig} disabled={sftpSaving || !sftpConfigured} style={{ background:'#fff', color:sftpConfigured ? '#374151' : '#9CA3AF', border:'1px solid #E5E7EB', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:sftpConfigured && !sftpSaving ? 'pointer' : 'not-allowed' }}>Test</button>
              <button onClick={saveSftpConfig} disabled={sftpSaving} style={{ background:sftpSaving ? '#9CA3AF' : '#1E2433', color:'#fff', border:'none', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:sftpSaving ? 'not-allowed' : 'pointer' }}>{sftpSaving ? 'Saving...' : 'Save SFTP'}</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ShipbobSettingsModal = () => {
    if (!shipbobOpen) return null;
    return (
      <div onClick={() => setShipbobOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(680px, 100%)', maxHeight:'min(720px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><Truck size={16} color="#006FDD"/>ShipBob</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Send matching orders to ShipBob for fulfillment.</div>
            </div>
            <button onClick={() => setShipbobOpen(false)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:16, overflow:'auto', display:'grid', gap:12 }}>
            <label style={{ display:'grid', gap:6 }}>
              <span style={labelStyle}>API TOKEN</span>
              <input type="password" value={shipbobForm.token} onChange={e => setShipbobForm(f => ({ ...f, token:e.target.value }))} placeholder={shipbobConfig?.connection?.hasToken ? 'Stored, leave blank to keep' : 'ShipBob personal access token'} style={inputStyle}/>
            </label>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) minmax(0, 1fr)', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>CHANNEL ID</span>
                <input value={shipbobForm.channelId} onChange={e => setShipbobForm(f => ({ ...f, channelId:e.target.value }))} placeholder="128943" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>SHIPPING METHOD</span>
                <input value={shipbobForm.shippingMethod} onChange={e => setShipbobForm(f => ({ ...f, shippingMethod:e.target.value }))} placeholder="Standard" style={inputStyle}/>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) minmax(0, 1fr)', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>ORDER TYPE</span>
                <input value={shipbobForm.orderType} onChange={e => setShipbobForm(f => ({ ...f, orderType:e.target.value }))} placeholder="DTC" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>LOCATION ID</span>
                <input value={shipbobForm.locationId} onChange={e => setShipbobForm(f => ({ ...f, locationId:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
            </div>
            <label style={{ display:'flex', gap:9, alignItems:'flex-start', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 11px', cursor:'pointer', background:shipbobForm.autoPush ? '#F0F6FF' : '#fff' }}>
              <input type="checkbox" checked={shipbobForm.autoPush} onChange={e => setShipbobForm(f => ({ ...f, autoPush:e.target.checked }))} style={{ marginTop:2, flexShrink:0 }}/>
              <span>
                <span style={{ display:'block', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>Auto-send new matching orders</span>
                <span style={{ display:'block', fontSize:11, color:'#6B7280', lineHeight:1.35, marginTop:2 }}>Omnifill sends matching paid orders after imports or source syncs and records only orders ShipBob accepts.</span>
              </span>
            </label>
            <div style={{ fontSize:11, color:'#6B7280', lineHeight:1.45 }}>ShipBob uses product reference IDs. Make sure every product in this destination has the same SKU/reference ID that exists in ShipBob.</div>
          </div>
          <div style={{ padding:'12px 16px', borderTop:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
            <div style={{ fontSize:11, color:'#9CA3AF' }}>{shipbobConfig?.connection?.lastTestStatus === 'ok' ? 'Last test succeeded.' : shipbobConfig?.connection?.lastTestStatus === 'error' ? 'Last test failed.' : 'Save settings before testing.'}</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', justifyContent:'flex-end' }}>
              <button onClick={testShipbobConfig} disabled={shipbobSaving || !shipbobConfigured} style={{ background:'#fff', color:shipbobConfigured ? '#374151' : '#9CA3AF', border:'1px solid #E5E7EB', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:shipbobConfigured && !shipbobSaving ? 'pointer' : 'not-allowed' }}>Test</button>
              <button onClick={saveShipbobConfig} disabled={shipbobSaving} style={{ background:shipbobSaving ? '#9CA3AF' : '#1E2433', color:'#fff', border:'none', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:shipbobSaving ? 'not-allowed' : 'pointer' }}>{shipbobSaving ? 'Saving...' : 'Save ShipBob'}</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DcixSettingsModal = () => {
    if (!dcixOpen) return null;
    return (
      <div onClick={() => setDcixOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(17,24,39,0.32)', zIndex:80, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div onClick={e => e.stopPropagation()} style={{ width:'min(760px, 100%)', maxHeight:'min(800px, calc(100vh - 32px))', background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, boxShadow:'0 24px 70px rgba(0,0,0,0.2)', display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14 }}>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:16, fontWeight:900, color:'#1A1A2E' }}><Truck size={16} color="#006FDD"/>DCIx warehouse API</div>
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:3 }}>Send matching orders to Data Integrator orderV01.</div>
            </div>
            <button onClick={() => setDcixOpen(false)} style={{ background:'none', border:'none', fontSize:24, color:'#9CA3AF', cursor:'pointer', lineHeight:1 }}>×</button>
          </div>
          <div style={{ padding:16, overflow:'auto', display:'grid', gap:12 }}>
            <div style={{ display:'grid', gridTemplateColumns:'minmax(0, 1fr) minmax(160px, 240px)', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>API BASE URL</span>
                <input value={dcixForm.baseUrl} onChange={e => setDcixForm(f => ({ ...f, baseUrl:e.target.value }))} placeholder="https://warehouse.example.com" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>IMPORT SYSTEM</span>
                <input value={dcixForm.system} onChange={e => setDcixForm(f => ({ ...f, system:e.target.value }))} placeholder="Omnifill" style={inputStyle}/>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>LOGIN NAME</span>
                <input value={dcixForm.userName} onChange={e => setDcixForm(f => ({ ...f, userName:e.target.value }))} placeholder={dcixConfig?.connection?.hasUserName ? 'Stored, leave blank to keep' : 'DCIx user'} style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>PASSWORD</span>
                <input type="password" value={dcixForm.password} onChange={e => setDcixForm(f => ({ ...f, password:e.target.value }))} placeholder={dcixConfig?.connection?.hasPassword ? 'Stored, leave blank to keep' : 'Password'} style={inputStyle}/>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>AUTHENTICATION KEY</span>
                <input type="password" value={dcixForm.authenticationKey} onChange={e => setDcixForm(f => ({ ...f, authenticationKey:e.target.value }))} placeholder={dcixConfig?.connection?.hasAuthenticationKey ? 'Stored, leave blank to keep' : 'Alternative to password login'} style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>DEVICE IDENTIFIER</span>
                <input value={dcixForm.deviceIdentifier} onChange={e => setDcixForm(f => ({ ...f, deviceIdentifier:e.target.value }))} placeholder={dcixConfig?.connection?.hasDeviceIdentifier ? 'Stored, leave blank to keep' : 'Required with authentication key'} style={inputStyle}/>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>ORDER DEFINITION</span>
                <input value={dcixForm.orderDefinitionName} onChange={e => setDcixForm(f => ({ ...f, orderDefinitionName:e.target.value }))} placeholder="salesOrder" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>ORDER STATE</span>
                <input value={dcixForm.orderState} onChange={e => setDcixForm(f => ({ ...f, orderState:e.target.value }))} placeholder="Released" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>SOURCE NAME</span>
                <input value={dcixForm.sourceName} onChange={e => setDcixForm(f => ({ ...f, sourceName:e.target.value }))} placeholder="Omnifill" style={inputStyle}/>
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:10 }}>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>COMPANY CODE</span>
                <input value={dcixForm.companyCode} onChange={e => setDcixForm(f => ({ ...f, companyCode:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>LOCATION CODE</span>
                <input value={dcixForm.locationCode} onChange={e => setDcixForm(f => ({ ...f, locationCode:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>FROM WAREHOUSE</span>
                <input value={dcixForm.fromWarehouseCode} onChange={e => setDcixForm(f => ({ ...f, fromWarehouseCode:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
              <label style={{ display:'grid', gap:6 }}>
                <span style={labelStyle}>TO WAREHOUSE</span>
                <input value={dcixForm.toWarehouseCode} onChange={e => setDcixForm(f => ({ ...f, toWarehouseCode:e.target.value }))} placeholder="Optional" style={inputStyle}/>
              </label>
            </div>
            <label style={{ display:'flex', gap:9, alignItems:'flex-start', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 11px', cursor:'pointer', background:dcixForm.autoPush ? '#F0F6FF' : '#fff' }}>
              <input type="checkbox" checked={dcixForm.autoPush} onChange={e => setDcixForm(f => ({ ...f, autoPush:e.target.checked }))} style={{ marginTop:2, flexShrink:0 }}/>
              <span>
                <span style={{ display:'block', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>Auto-send new matching orders</span>
                <span style={{ display:'block', fontSize:11, color:'#6B7280', lineHeight:1.35, marginTop:2 }}>After imports or source syncs, Omnifill sends matching paid orders and records only batches DCIx accepts.</span>
              </span>
            </label>
            <div style={{ fontSize:11, color:'#6B7280', lineHeight:1.45 }}>Real sends return a request ID when DCIx provides one.</div>
          </div>
          <div style={{ padding:'12px 16px', borderTop:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
            <div style={{ fontSize:11, color:'#9CA3AF' }}>{dcixConfig?.connection?.lastTestStatus === 'ok' ? 'Last login succeeded.' : dcixConfig?.connection?.lastTestStatus === 'error' ? 'Last login failed.' : 'Save settings before testing.'}</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', justifyContent:'flex-end' }}>
              <button onClick={testDcixConfig} disabled={dcixSaving || !dcixConfigured} style={{ background:'#fff', color:dcixConfigured ? '#374151' : '#9CA3AF', border:'1px solid #E5E7EB', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:dcixConfigured && !dcixSaving ? 'pointer' : 'not-allowed' }}>Test login</button>
              <button onClick={saveDcixConfig} disabled={dcixSaving} style={{ background:dcixSaving ? '#9CA3AF' : '#1E2433', color:'#fff', border:'none', borderRadius:8, padding:'8px 12px', fontSize:12, fontWeight:900, cursor:dcixSaving ? 'not-allowed' : 'pointer' }}>{dcixSaving ? 'Saving...' : 'Save DCIx'}</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="dash-page-scroll export-rules-page">
      <div className="export-workspace-header">
        <div>
          <h1 className="dash-page-title">Export</h1>
          <p className="dash-page-subtitle" style={{ maxWidth:820 }}>Route orders to fulfillment destinations, then download a CSV or send them automatically.</p>
        </div>
        <button onClick={startNew} disabled={createDisabled} style={{ justifyContent:'center', background:createDisabled ? '#9CA3AF' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 12px', fontSize:13, fontWeight:900, cursor:createDisabled ? 'not-allowed' : 'pointer', display:'flex', alignItems:'center', gap:6, whiteSpace:'nowrap' }}>
          <Plus size={13} strokeWidth={2.4}/>{creating ? 'Creating...' : 'New destination'}
        </button>
      </div>

      <div className="export-rules-grid">
        <div className="export-destinations-column">
          <div className="export-destinations-pane">
            <div style={{ padding:'14px 16px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
              <div style={{ fontSize:13, fontWeight:900 }}>Destinations</div>
              <div style={{ fontSize:12, color:'#6B7280', fontWeight:800 }}>{rules.length}</div>
            </div>
            {createError && <div style={{ padding:'9px 14px', borderBottom:'1px solid #FEE2E2', background:'#FEF2F2', color:'#991B1B', fontSize:12, fontWeight:800 }}>{createError}</div>}
            {loadError && (
              <div style={{ padding:'10px 14px', borderBottom:'1px solid #FEE2E2', background:'#FEF2F2', color:'#991B1B', fontSize:12, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
                <span style={{ lineHeight:1.35 }}>{loadError}</span>
                <button onClick={() => loadRules(selectedId)} style={{ flexShrink:0, background:'#fff', color:'#991B1B', border:'1px solid #FCA5A5', borderRadius:7, padding:'6px 8px', fontSize:11, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:5 }}>
                  <RefreshCw size={12}/>Retry
                </button>
              </div>
            )}
            <div style={{ maxHeight:520, overflow:'auto' }}>
              {initialRulesLoading ? (
                <ExportDestinationListSkeleton/>
              ) : rules.length === 0 ? (
                <div style={{ padding:18, fontSize:13, color:'#9CA3AF' }}>{loadError ? 'Retry to load your saved destinations.' : 'No export destinations yet.'}</div>
              ) : rules.map(rule => {
                const active = rule.id === selectedId;
                const DestinationIcon = rule.criteria?.allOrders === true ? FileSpreadsheet : Truck;
                return (
                  <button key={rule.id} onClick={() => selectRule(rule)} className={`export-rule-sidebar-row ${active ? 'is-selected' : ''}`} style={{ width:'100%', textAlign:'left', background:active ? '#F0F6FF' : '#fff', border:'none', borderBottom:'1px solid #F3F4F6', padding:'12px 14px', cursor:'pointer' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:10, alignItems:'center' }}>
                      <span style={{ minWidth:0, display:'flex', alignItems:'center', gap:8 }}>
                        <DestinationIcon size={16} color={active ? '#006FDD' : '#6B7280'} strokeWidth={2} style={{ flexShrink:0 }}/>
                        <span style={{ fontSize:15, fontWeight:900, color:'#1A1A2E', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{rule.name || rule.destination}</span>
                      </span>
                      <span style={{ fontSize:11, color:'#374151', background:'#F3F4F6', borderRadius:5, padding:'2px 6px', fontWeight:800 }}>{rule.matchCount || 0}</span>
                    </div>
                    <div style={{ fontSize:11, color:'#6B7280', marginTop:4 }}>{deliverySummaryForRule(rule)}. CSV fallback always available.</div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {initialRulesLoading ? (
          <ExportRuleDetailSkeleton/>
        ) : loadError && !selectedRule && rules.length === 0 ? (
          <ExportRulesLoadErrorPanel onRetry={() => loadRules(selectedId)}/>
        ) : selectedRule ? (
        <div className="export-rule-detail">
          <div className="export-detail-section export-destination-heading" style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, padding:16 }}>
            <div>
              <label style={labelStyle}>DESTINATION</label>
              <div style={{ display:'grid', gridTemplateColumns:'34px minmax(0, 1fr)', gap:10, alignItems:'center' }}>
                <span style={{ width:34, height:34, borderRadius:7, background:'#EEF6FF', color:'#006FDD', display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
                  {isAllOrdersDestination ? <FileSpreadsheet size={18}/> : <Truck size={18}/>}
                </span>
                <input value={form.destination} onChange={e => setForm(f => ({ ...f, destination:e.target.value, name:e.target.value }))} placeholder="US warehouse, EU 3PL, GamesQuest" style={{ ...inputStyle, fontSize:20, fontWeight:900, padding:'11px 12px', letterSpacing:0 }}/>
              </div>
            </div>

            {isAllOrdersDestination && <div style={{ fontSize:12, color:'#6B7280', marginTop:10 }}>Starts with every order included. You can rename it and adjust any setting.</div>}
            <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginTop:14 }}>
              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:'#374151' }}><input type="checkbox" checked={form.criteria.paidOnly} onChange={e => setCriteria({ paidOnly:e.target.checked })}/> Paid orders only</label>
              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:'#374151' }}><input type="checkbox" checked={form.criteria.excludeRouted} onChange={e => setCriteria({ excludeRouted:e.target.checked })}/> Exclude orders already sent</label>
              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:'#374151' }}><input type="checkbox" checked={form.criteria.includeFulfilled} onChange={e => setCriteria({ includeFulfilled:e.target.checked })}/> Include fulfilled orders</label>
            </div>
            {editing && (
              <div style={{ marginTop:12 }}>
                <button onClick={() => setActivityOpen(true)} style={{ background:'#fff', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
                  <Clock3 size={13}/>View activity
                </button>
              </div>
            )}
          </div>

          <div className="export-detail-section" style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, padding:16 }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}><SlidersHorizontal size={15} color="#006FDD"/><div style={{ fontSize:13, fontWeight:900 }}>Which orders should be included?</div></div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:16 }}>
              <ChoiceButton title="Products / SKUs" count={form.criteria.productIds.includes(NO_PRODUCTS_SELECTED) ? 0 : (form.criteria.productIds.length ? explicitProducts().length : fulfillableProductIds.length)} summary={selectedProductSummary()} onClick={() => setPicker('products')}/>
              <ChoiceButton title="Destination region" count={explicitCountries().length} summary={selectedDestinationSummary()} onClick={() => setPicker('countries')}/>
              <ChoiceButton title="Order timeline" valueLabel={form.criteria.datePreset ? 'Filtered' : ''} summary={timelineSummary} onClick={() => setTimelineOpen(true)}/>
            </div>
            <button onClick={() => setRoutingAdvancedOpen(true)} style={{ marginTop:12, width:'100%', background:'#F9FAFB', border:'1px solid #F3F4F6', borderRadius:8, padding:'9px 10px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, cursor:'pointer', color:'#374151' }}>
              <span style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:900 }}><SlidersHorizontal size={13} color="#6B7280"/>Advanced settings</span>
              <span style={{ display:'flex', alignItems:'center', gap:7, fontSize:11, fontWeight:900, color:advancedActiveCount ? '#006FDD' : '#9CA3AF' }}>
                {advancedActiveCount ? `${advancedActiveCount} active` : 'Optional'}
                <ArrowRight size={13} color={advancedActiveCount ? '#006FDD' : '#9CA3AF'}/>
              </span>
            </button>
          </div>

          <div className="export-match-summary" style={{ marginTop:-6, padding:'0 2px', fontSize:11, color:'#6B7280' }}>
            Current draft matches {ordersLoading
              ? <SkeletonPill width={34} height={11}/>
              : <strong style={{ color:'#1A1A2E' }}>{matchingOrders.length}</strong>
            } order{!ordersLoading && matchingOrders.length === 1 ? '' : 's'}.
          </div>

          <div className="export-detail-section" style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden' }}>
            <div style={{ padding:'14px 18px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
              <div><div style={{ fontSize:13, fontWeight:900 }}>CSV format</div><div style={{ fontSize:12, color:'#9CA3AF', marginTop:2 }}>Start with a ready partner format. Open manual editing only when a warehouse gives you a custom column template.</div></div>
              <button onClick={() => setProfilePickerOpen(true)} style={{ width:300, maxWidth:'min(300px, 100%)', minHeight:44, background:'#fff', border:'1px solid #D7E7FF', borderRadius:8, padding:'7px 10px', display:'grid', gridTemplateColumns:'auto minmax(0, 1fr) auto', alignItems:'center', gap:9, cursor:'pointer', textAlign:'left' }}>
                <span style={{ width:28, height:28, borderRadius:7, background:'#EEF6FF', display:'inline-flex', alignItems:'center', justifyContent:'center' }}><FileSpreadsheet size={14} color="#006FDD"/></span>
                <span style={{ minWidth:0 }}>
                  <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>{selectedCsvFormat ? selectedCsvFormat.name : selectedProfile ? selectedProfile.name : 'Choose or save format'}</span>
                  <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:10, fontWeight:800, color:'#6B7280' }}>{selectedCsvFormat ? `Saved format - ${selectedCsvFormat.mapping.length} columns` : selectedProfile ? `${selectedProfile.partner} - ${selectedProfile.region}` : 'Saved formats and partner presets'}</span>
                </span>
                <Search size={14} color="#9CA3AF"/>
              </button>
            </div>

            <button onClick={() => setCsvManualOpen(open => !open)} aria-expanded={csvManualOpen} style={{ width:'100%', border:'none', background:'#FAFBFC', borderBottom:csvManualOpen ? '1px solid #F3F4F6' : 'none', padding:'11px 18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, textAlign:'left' }}>
              <span style={{ minWidth:0 }}>
                <span style={{ display:'block', fontSize:12, fontWeight:900, color:'#1A1A2E' }}>Edit manually</span>
                <span style={{ display:'block', fontSize:11, color:'#6B7280', marginTop:2 }}>{form.mapping.length} columns mapped. Use this only for custom CSV specs.</span>
              </span>
              <span style={{ display:'inline-flex', alignItems:'center', gap:8, flexShrink:0, fontSize:11, fontWeight:900, color:'#006FDD' }}>
                {csvManualOpen ? 'Hide columns' : 'Show columns'}
                <ChevronDown size={15} style={{ transform:csvManualOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition:'transform 140ms ease' }}/>
              </span>
            </button>

            {csvManualOpen && (
              <div>
                <div style={{ padding:'10px 12px', display:'flex', justifyContent:'flex-end', borderBottom:'1px solid #F3F4F6' }}>
                  <button onClick={addMappingRow} style={{ background:'#F9FAFB', border:'1px solid #E5E7EB', borderRadius:7, padding:'7px 9px', fontSize:12, fontWeight:800, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}><Plus size={13}/> Column</button>
                </div>
                <div style={{ overflowX:'auto' }}>
                  <table style={{ width:'100%', minWidth:620, borderCollapse:'collapse', fontSize:13 }}>
                    <thead><tr style={{ background:'#F9FAFB', borderBottom:'1px solid #E5E7EB' }}>{['','Partner column','Omnifill field','Move',''].map((h, index) => <th key={index} style={{ textAlign:'left', padding:'9px 12px', color:'#9CA3AF', fontSize:11, fontWeight:900 }}>{h}</th>)}</tr></thead>
                    <tbody>
                      {form.mapping.map((row, idx) => (
                        <tr key={idx} style={{ borderBottom:'1px solid #F3F4F6' }}>
                          <td style={{ padding:'8px 12px', width:44 }}>
                            <button type="button" title="Move column" style={{ width:30, height:30, border:'1px solid #E5E7EB', borderRadius:8, background:'#F9FAFB', display:'inline-flex', alignItems:'center', justifyContent:'center', color:'#6B7280', cursor:'grab' }}>
                              <GripVertical size={16} strokeWidth={1.8}/>
                            </button>
                          </td>
                          <td style={{ padding:'8px 12px' }}><input value={row.header} onChange={e => setMappingRow(idx, { header:e.target.value })} style={{ ...inputStyle, fontFamily:'monospace' }}/></td>
                          <td style={{ padding:'8px 12px' }}><select value={row.field} onChange={e => setMappingRow(idx, { field:e.target.value })} style={inputStyle}>{fields.map(f => <option key={f.key} value={f.key}>{f.label}</option>)}</select></td>
                          <td style={{ padding:'8px 12px', width:92, display:'flex', gap:6, justifyContent:'flex-end' }}>
                            <button type="button" onClick={() => moveMappingRow(idx, -1)} disabled={idx === 0} title="Move up" style={{ width:30, height:30, border:'1px solid #E5E7EB', borderRadius:8, background:idx === 0 ? '#F3F4F6' : '#fff', color:idx === 0 ? '#9CA3AF' : '#374151', cursor:idx === 0 ? 'not-allowed' : 'pointer', display:'inline-flex', alignItems:'center', justifyContent:'center' }}><ChevronUp size={14}/></button>
                            <button type="button" onClick={() => moveMappingRow(idx, 1)} disabled={idx === form.mapping.length - 1} title="Move down" style={{ width:30, height:30, border:'1px solid #E5E7EB', borderRadius:8, background:idx === form.mapping.length - 1 ? '#F3F4F6' : '#fff', color:idx === form.mapping.length - 1 ? '#9CA3AF' : '#374151', cursor:idx === form.mapping.length - 1 ? 'not-allowed' : 'pointer', display:'inline-flex', alignItems:'center', justifyContent:'center' }}><ChevronDown size={14}/></button>
                          </td>
                          <td style={{ padding:'8px 12px', width:54 }}><button onClick={() => removeMappingRow(idx)} title="Remove column" style={{ background:'#fff', color:'#DC2626', border:'1px solid #FEE2E2', borderRadius:7, padding:7, cursor:'pointer', display:'flex' }}><Trash2 size={13}/></button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {editing && (
            <>
              <div className="export-detail-section" style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden' }}>
                <div style={{ padding:'14px 18px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
                  <div>
                    <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:900 }}><Truck size={15} color="#006FDD"/>Automatic Sending Method</div>
                    <div style={{ fontSize:12, color:'#9CA3AF', marginTop:2 }}>Default is None. Choose a focused method only when new matching orders should send automatically.</div>
                  </div>
                  <button onClick={() => setMethodCatalogOpen(true)} style={{ background:'#EEF6FF', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
                    <Search size={13}/>{deliveryFocus === 'none' ? 'Choose method' : 'Change method'}
                  </button>
                </div>

                <div style={{ padding:14, display:'grid', gap:12 }}>
                  {deliveryFocus === 'none' ? (
                    <div style={{ border:'1px dashed #CBD5E1', borderRadius:8, padding:'14px', display:'grid', gap:7 }}>
                      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:900, color:'#1A1A2E' }}><XCircle size={15} color="#6B7280"/>None</div>
                        <StatusChip status={focusedMethodStatus}/>
                      </div>
                      <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.45 }}>New matching orders will not be sent automatically. Manual CSV export remains available.</div>
                    </div>
                  ) : (
                    <div style={{ border:'1px solid #E5E7EB', borderRadius:8, overflow:'hidden' }}>
                      <div style={{ padding:'12px 13px', background:'#FAFBFC', borderBottom:'1px solid #F3F4F6', display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, flexWrap:'wrap' }}>
                        <div style={{ minWidth:0 }}>
                          <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:900, color:'#1A1A2E' }}>
                            {React.createElement(focusedMethod.Icon, { size:15, color:'#006FDD' })}{focusedMethod.name}
                          </div>
                          <div style={{ fontSize:11, color:'#6B7280', marginTop:2 }}>{focusedMethod.description}</div>
                        </div>
                        <StatusChip status={focusedMethodStatus}/>
                      </div>

                      <div style={{ padding:13, display:'grid', gap:12 }}>
                        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(145px, 1fr))', gap:8 }}>
                          <div style={{ border:'1px solid #F3F4F6', borderRadius:7, padding:'9px 10px' }}>
                            <div style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.05em' }}>Matches</div>
                            <div style={{ marginTop:5, fontSize:18, fontWeight:900, color:'#1A1A2E' }}>{ordersLoading ? <SkeletonPill width={34} height={18}/> : matchingOrders.length}</div>
                          </div>
                          <div style={{ border:'1px solid #F3F4F6', borderRadius:7, padding:'9px 10px' }}>
                            <div style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.05em' }}>Missing SKUs</div>
                            <div style={{ marginTop:5, fontSize:18, fontWeight:900, color:selectedMethodNeedsSku && currentMissingSkuCount ? '#DC2626' : '#166534' }}>{ordersLoading ? <SkeletonPill width={34} height={18}/> : currentMissingSkuCount}</div>
                          </div>
                          <div style={{ border:'1px solid #F3F4F6', borderRadius:7, padding:'9px 10px' }}>
                            <div style={{ fontSize:10, fontWeight:900, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.05em' }}>Missing addresses</div>
                            <div style={{ marginTop:5, fontSize:18, fontWeight:900, color:selectedMethodNeedsAddress && currentMissingAddressCount ? '#DC2626' : '#166534' }}>{ordersLoading ? <SkeletonPill width={34} height={18}/> : currentMissingAddressCount}</div>
                          </div>
                        </div>

                        {deliveryFocus === 'sftp' && (
                          <div style={{ display:'grid', gap:10 }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:sftpConfigured ? '#374151' : '#9CA3AF' }}>
                                <input type="checkbox" disabled={!sftpConfigured} checked={!!sftpConfig?.autoPush} onChange={e => toggleSftpAutoPush(e.target.checked)}/>
                                Auto-push new orders
                              </label>
                              {sftpConfig?.lastError && <div style={{ fontSize:11, color:'#DC2626', fontWeight:800 }}>Last error: {sftpConfig.lastError}</div>}
                            </div>
                            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                              <button onClick={() => setSftpOpen(true)} style={{ background:'#fff', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}><Upload size={13}/>{sftpConfigured ? 'Edit SFTP' : 'Set up SFTP'}</button>
                              <button onClick={pingSftpConfig} disabled={!sftpConfigured || sftpSaving} title="Upload a harmless test CSV to this destination's SFTP folder" style={{ background:'#EEF6FF', color:sftpConfigured && !sftpSaving ? '#006FDD' : '#9CA3AF', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:sftpConfigured && !sftpSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><RefreshCw size={13}/>Test ping</button>
                              <button onClick={pushSftpNow} disabled={!sftpConfigured || sftpSaving} style={{ background:!sftpConfigured || sftpSaving ? '#D1D5DB' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:sftpConfigured && !sftpSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><Zap size={13}/>{sftpSaving ? 'Pushing...' : 'Push to SFTP'}</button>
                            </div>
                          </div>
                        )}

                        {deliveryFocus === 'shipbob' && (
                          <div style={{ display:'grid', gap:10 }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:shipbobConfigured ? '#374151' : '#9CA3AF' }}>
                                <input type="checkbox" disabled={!shipbobConfigured} checked={!!shipbobConfig?.autoPush} onChange={e => toggleShipbobAutoPush(e.target.checked)}/>
                                Auto-send new orders
                              </label>
                              {shipbobConfig?.lastError && <div style={{ fontSize:11, color:'#DC2626', fontWeight:800 }}>Last error: {shipbobConfig.lastError}</div>}
                            </div>
                            <div style={{ fontSize:11, color:'#6B7280', lineHeight:1.45 }}>Make sure every product in this destination has the same SKU/reference ID that exists in ShipBob.</div>
                            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                              <button onClick={() => setShipbobOpen(true)} style={{ background:'#fff', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}><Truck size={13}/>{shipbobConfigured ? 'Edit ShipBob' : 'Set up ShipBob'}</button>
                              <button onClick={pingShipbobConfig} disabled={!shipbobConfigured || shipbobSaving} title="Ping the configured ShipBob channel without creating an order" style={{ background:'#EEF6FF', color:shipbobConfigured && !shipbobSaving ? '#006FDD' : '#9CA3AF', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:shipbobConfigured && !shipbobSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><RefreshCw size={13}/>Test ping</button>
                              <button onClick={pushShipbobNow} disabled={!shipbobConfigured || shipbobSaving} style={{ background:!shipbobConfigured || shipbobSaving ? '#D1D5DB' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:shipbobConfigured && !shipbobSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><Zap size={13}/>{shipbobSaving ? 'Sending...' : 'Send to ShipBob'}</button>
                            </div>
                          </div>
                        )}

                        {deliveryFocus === 'dcix' && (
                          <div style={{ display:'grid', gap:10 }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
                              <label style={{ display:'flex', alignItems:'center', gap:7, fontSize:12, fontWeight:800, color:dcixConfigured ? '#374151' : '#9CA3AF' }}>
                                <input type="checkbox" disabled={!dcixConfigured} checked={!!dcixConfig?.autoPush} onChange={e => toggleDcixAutoPush(e.target.checked)}/>
                                Auto-send new orders
                              </label>
                              {dcixConfig?.lastError && <div style={{ fontSize:11, color:'#DC2626', fontWeight:800 }}>Last error: {dcixConfig.lastError}</div>}
                            </div>
                            <div style={{ fontSize:11, color:'#6B7280', lineHeight:1.45 }}>Use this for the configured warehouse API connection.</div>
                            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                              <button onClick={() => setDcixOpen(true)} style={{ background:'#fff', color:'#006FDD', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}><Truck size={13}/>{dcixConfigured ? 'Edit DCIx' : 'Set up DCIx'}</button>
                              <button onClick={pingDcixConfig} disabled={!dcixConfigured || dcixSaving} title="Ping the configured DCIx system without creating an order" style={{ background:'#EEF6FF', color:dcixConfigured && !dcixSaving ? '#006FDD' : '#9CA3AF', border:'1px solid #BFD9FF', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:dcixConfigured && !dcixSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><RefreshCw size={13}/>Test ping</button>
                              <button onClick={pushDcixNow} disabled={!dcixConfigured || dcixSaving} style={{ background:!dcixConfigured || dcixSaving ? '#D1D5DB' : '#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'8px 11px', fontSize:12, fontWeight:900, cursor:dcixConfigured && !dcixSaving ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}><Zap size={13}/>{dcixSaving ? 'Sending...' : 'Send to DCIx'}</button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {editing && (
            <div className="export-detail-section export-download-section" style={{ background:'#fff', border:'1px solid #D7E7FF', borderRadius:8, overflow:'hidden' }}>
              <div style={{ padding:'14px 18px', borderBottom:'1px solid #E5EEFA', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, flexWrap:'wrap', background:'#FAFCFF' }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:900, color:'#1A1A2E' }}><Download size={15} color="#006FDD"/>Exports</div>
              </div>
              <div>
                <div style={{ padding:'13px 18px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, flexWrap:'wrap', borderBottom:'1px solid #F3F4F6' }}>
                  <div style={{ minWidth:180 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:7, fontSize:13, fontWeight:900, color:'#1A1A2E' }}><FileSpreadsheet size={15} color="#006FDD"/>CSV</div>
                    <div style={{ fontSize:11, color:'#6B7280', marginTop:3 }}>{exportCsvAssignedCount} assigned order{exportCsvAssignedCount === 1 ? '' : 's'} using the mapped columns</div>
                  </div>
                  <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', justifyContent:'flex-end' }}>
                    {!isAllOrdersDestination && <label style={{ display:'inline-flex', alignItems:'center', gap:7, fontSize:11, fontWeight:800, color:'#6B7280', cursor:'pointer' }}>
                      <input type="checkbox" checked={csvIncludeFulfilled} onChange={event => setCsvIncludeFulfilled(event.target.checked)}/>
                      Include fulfilled
                    </label>}
                    <button onClick={downloadRuleCsv} style={{ background:'#006FDD', color:'#fff', border:'none', borderRadius:8, padding:'10px 14px', fontSize:13, fontWeight:900, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:7 }}>
                      <Download size={14}/>Download CSV
                    </button>
                  </div>
                </div>

                <div style={{ padding:'13px 18px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, flexWrap:'wrap' }}>
                  <div style={{ minWidth:180 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:7, fontSize:13, fontWeight:900, color:'#1A1A2E' }}><FileText size={15} color="#6B7280"/>Invoice PDFs</div>
                    <div style={{ display:'flex', gap:10, flexWrap:'wrap', fontSize:11, color:'#6B7280', marginTop:3 }}>
                      <span>{exportInvoiceReadyCount} ready</span>
                      {!!exportInvoiceSkippedCount && <span style={{ color:'#B45309' }}>{exportInvoiceSkippedCount} incomplete</span>}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', justifyContent:'flex-end' }}>
                    {!isAllOrdersDestination && <label style={{ display:'inline-flex', alignItems:'center', gap:7, fontSize:11, fontWeight:800, color:'#6B7280', cursor:'pointer' }}>
                      <input type="checkbox" checked={invoiceIncludeFulfilled} onChange={event => setInvoiceIncludeFulfilled(event.target.checked)}/>
                      Include fulfilled
                    </label>}
                    <button onClick={openInvoiceSettings} title="Invoice settings" style={{ background:'#fff', color:'#374151', border:'1px solid #D1D5DB', borderRadius:8, padding:'10px 12px', fontSize:12, fontWeight:800, cursor:'pointer' }}>Settings</button>
                    <button onClick={() => setInvoiceBatchOpen(true)} disabled={!exportInvoiceMatchedCount} style={{ background:'#fff', color:exportInvoiceMatchedCount ? '#006FDD' : '#9CA3AF', border:`1px solid ${exportInvoiceMatchedCount ? '#BFD9FF' : '#E5E7EB'}`, borderRadius:8, padding:'10px 13px', fontSize:13, fontWeight:900, cursor:exportInvoiceMatchedCount ? 'pointer' : 'not-allowed', display:'inline-flex', alignItems:'center', gap:7 }}>
                      <FileText size={14}/>Prepare PDFs
                    </button>
                  </div>
                  {!!exportInvoiceSkippedPreview.length && (
                    <div title={`${exportInvoiceSkippedPreview[0].orderId} needs ${exportInvoiceSkippedPreview[0].issues.join(', ')}`} style={{ flexBasis:'100%', color:'#B45309', fontSize:11, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>Some invoices need more data. Open Prepare PDFs for details.</div>
                  )}
                </div>
              </div>
            </div>
          )}

          {(error || message) && (
            <div className="export-detail-notice" style={{ border:`1px solid ${error ? '#FCA5A5' : '#BBF7D0'}`, background:error ? '#FEF2F2' : '#F0FDF4', color:error ? '#991B1B' : '#166534', borderRadius:9, padding:'10px 12px', fontSize:12, fontWeight:800 }}>
              {error || message}
            </div>
          )}

          <div className="export-detail-actions" style={{ display:'flex', gap:10, justifyContent:'space-between', flexWrap:'wrap' }}>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              {editing && !isAllOrdersDestination && <button onClick={deleteRule} style={{ background:'#fff', color:'#DC2626', border:'1px solid #FCA5A5', borderRadius:8, padding:'9px 12px', fontSize:13, fontWeight:800, cursor:'pointer', display:'flex', alignItems:'center', gap:7 }}><Trash2 size={14}/> Delete destination</button>}
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={() => saveRule()} disabled={saving} style={{ background:saving ? '#9CA3AF' : '#1E2433', color:'#fff', border:'none', borderRadius:8, padding:'9px 13px', fontSize:13, fontWeight:900, cursor:saving ? 'not-allowed' : 'pointer', display:'flex', alignItems:'center', gap:7 }}><Save size={14}/>{saving ? 'Saving...' : 'Save destination'}</button>
            </div>
          </div>
        </div>
        ) : (
          <div className="export-empty-detail" style={{ minHeight:520, background:'#fff', border:'1px solid #E5E7EB', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', padding:28 }}>
            <div style={{ textAlign:'center', maxWidth:360 }}>
              <FileSpreadsheet size={34} strokeWidth={1.7} color="#CBD5E1"/>
              <div style={{ fontSize:16, fontWeight:900, color:'#1A1A2E', marginTop:12 }}>Select a destination</div>
              <div style={{ fontSize:13, color:'#9CA3AF', lineHeight:1.45, marginTop:5 }}>Choose a destination from the list, or create a new one from the Destinations section.</div>
            </div>
          </div>
        )}
      </div>
      {PickerModal()}
      {TimelineModal()}
      {MethodCatalogModal()}
      {CsvProfilePickerModal()}
      {AdvancedSettingsModal()}
      {SftpSettingsModal()}
      {ShipbobSettingsModal()}
      {DcixSettingsModal()}
      {RuleActivityModal()}
      {invoiceBatchOpen && selectedRule && (
        <ExportInvoiceBatchModal
          rule={selectedRule}
          includeFulfilled={effectiveInvoiceIncludeFulfilled}
          onClose={() => setInvoiceBatchOpen(false)}
          onNavigate={onNavigate}
          onComplete={(invoiceCount, skippedCount) => {
            setMessage(`${invoiceCount} invoice PDF${invoiceCount === 1 ? '' : 's'} downloaded${skippedCount ? `; ${skippedCount} incomplete order${skippedCount === 1 ? '' : 's'} skipped` : ''}.`);
          }}
        />
      )}
    </div>
  );
};
